import { format } from 'date-fns';
import { PRESET_QUESTIONS } from '../containers/step-3/mockData';

export const DEFAULT_DATE = new Date(Date.now() + 86400000);

export const DEFAULT_START_DATE = format(new Date(DEFAULT_DATE.setHours(new Date().getHours() + 1, 0, 0, 0)), 'yyyy-MM-dd HH:mm:ss');

export const DEFAULT_END_DATE = format(new Date(DEFAULT_DATE.setHours(new Date().getHours() + 2, 0, 0, 0)), 'yyyy-MM-dd HH:mm:ss');

export const DEFAULT_STATE = {
  name: '',
  visibility: '',
  category:'',
  type: '',
  tag: 'EVENTS_TICKETING',
  start_date: DEFAULT_START_DATE,
  end_date: DEFAULT_END_DATE,
  meeting_link: '',
  meeting_id: '',
  meeting_password: '',
  event_address: {
    venue: '',
    address_line_1: '',
    address_line_2: '',
    city: '',
    state: 'Tamil Nadu',
    location: {
        lat: 13.067439,
        lng: 80.237617,
    },
  },
  is_place_mapping: true,
  geo_location: '',
  full_image: null,
  image: null,
  crop: null,
  description: '',
  note: '',
  mobile: '',
  smp_detail_entity_set: [],
  get_to_know_details: PRESET_QUESTIONS,
  status: 'PENDING',
  is_active: false,
  is_delete: false,
}

export const MODULES = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['link'],
  ],
};

export const INDIAN_CITIES = [
  {
      "id": "Adambakkam",
      "label": "Adambakkam",
      "Latitude": 12.981241,
      "Longitude": 80.20945,
      "State": "Tamil Nadu"
  },
  {
      "id": "Adilabad",
      "label": "Adilabad",
      "Latitude": 19.6667,
      "Longitude": 78.533302,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Adyar",
      "label": "Adyar",
      "Latitude": 13.003387,
      "Longitude": 80.255043,
      "State": "Tamil Nadu"
  },
  {
      "id": "Agar Malwa",
      "label": "Agar Malwa",
      "Latitude": 23.710348,
      "Longitude": 76.010178,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Agartala",
      "label": "Agartala",
      "Latitude": 23.829321,
      "Longitude": 91.277847,
      "State": "Tripura"
  },
  {
      "id": "Agra",
      "label": "Agra",
      "Latitude": 27.17667,
      "Longitude": 78.008072,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Ahmedabad",
      "label": "Ahmedabad",
      "Latitude": 23.033863,
      "Longitude": 72.585022,
      "State": "Gujarat"
  },
  {
      "id": "Ahmednagar",
      "label": "Ahmednagar",
      "Latitude": 19.101053,
      "Longitude": 74.740677,
      "State": "Maharashtra"
  },
  {
      "id": "Aizawl",
      "label": "Aizawl",
      "Latitude": 23.727106,
      "Longitude": 92.717636,
      "State": "Mizoram"
  },
  {
      "id": "Ajitgarh",
      "label": "Ajitgarh",
      "Latitude": 30.7076,
      "Longitude": 76.715126,
      "State": "Punjab"
  },
  {
      "id": "Ajmer",
      "label": "Ajmer",
      "Latitude": 26.449896,
      "Longitude": 74.639915,
      "State": "Rajasthan"
  },
  {
      "id": "Akola",
      "label": "Akola",
      "Latitude": 20.707228,
      "Longitude": 77.00296,
      "State": "Maharashtra"
  },
  {
      "id": "Akot",
      "label": "Akot",
      "Latitude": 21.1,
      "Longitude": 77.059998,
      "State": "Maharashtra"
  },
  {
      "id": "Alambagh",
      "label": "Alambagh",
      "Latitude": 26.805687,
      "Longitude": 80.914993,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Aland",
      "label": "Aland",
      "Latitude": 17.570721,
      "Longitude": 76.569733,
      "State": "Karnataka"
  },
  {
      "id": "Aligarh",
      "label": "Aligarh",
      "Latitude": 27.900383,
      "Longitude": 78.072281,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Alipurduar",
      "label": "Alipurduar",
      "Latitude": 26.49189,
      "Longitude": 89.5271,
      "State": "West Bengal"
  },
  {
      "id": "Almora",
      "label": "Almora",
      "Latitude": 29.594189,
      "Longitude": 79.653893,
      "State": "Uttarakhand"
  },
  {
      "id": "Alwar",
      "label": "Alwar",
      "Latitude": 27.560932,
      "Longitude": 76.625015,
      "State": "Rajasthan"
  },
  {
      "id": "Amalner",
      "label": "Amalner",
      "Latitude": 21.04241,
      "Longitude": 75.063873,
      "State": "Maharashtra"
  },
  {
      "id": "Amalsad",
      "label": "Amalsad",
      "Latitude": 20.817595,
      "Longitude": 72.954918,
      "State": "Gujarat"
  },
  {
      "id": "Ambala label",
      "label": "Ambala label",
      "Latitude": 30.37818,
      "Longitude": 76.776695,
      "State": "Haryana"
  },
  {
      "id": "Ambernath",
      "label": "Ambernath",
      "Latitude": 19.186354,
      "Longitude": 73.191948,
      "State": "Maharashtra"
  },
  {
      "id": "Ambikapur",
      "label": "Ambikapur",
      "Latitude": 23.116444,
      "Longitude": 83.196121,
      "State": "Chhattisgarh"
  },
  {
      "id": "Ameerpet",
      "label": "Ameerpet",
      "Latitude": 17.437462,
      "Longitude": 78.448288,
      "State": "Telangana"
  },
  {
      "id": "Amravati",
      "label": "Amravati",
      "Latitude": 20.937424,
      "Longitude": 77.779549,
      "State": "Maharashtra"
  },
  {
      "id": "Amreli",
      "label": "Amreli",
      "Latitude": 21.603176,
      "Longitude": 71.222084,
      "State": "Gujarat"
  },
  {
      "id": "Amritsar",
      "label": "Amritsar",
      "Latitude": 31.63398,
      "Longitude": 74.872261,
      "State": "Punjab"
  },
  {
      "id": "Amroha",
      "label": "Amroha",
      "Latitude": 28.902397,
      "Longitude": 78.465042,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Anakapalle",
      "label": "Anakapalle",
      "Latitude": 17.686001,
      "Longitude": 83.008781,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Anakaputhur",
      "label": "Anakaputhur",
      "Latitude": 12.946366,
      "Longitude": 79.959244,
      "State": "Tamil Nadu"
  },
  {
      "id": "Anand",
      "label": "Anand",
      "Latitude": 22.554029,
      "Longitude": 72.948936,
      "State": "Gujarat"
  },
  {
      "id": "Anandapur",
      "label": "Anandapur",
      "Latitude": 21.2155,
      "Longitude": 86.1222,
      "State": "Odisha"
  },
  {
      "id": "Anantapur",
      "label": "Anantapur",
      "Latitude": 14.685564,
      "Longitude": 77.595406,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Anantnag",
      "label": "Anantnag",
      "Latitude": 33.729729,
      "Longitude": 75.14978,
      "State": "Jammu and Kashmir"
  },
  {
      "id": "Andheri",
      "label": "Andheri",
      "Latitude": 19.116625,
      "Longitude": 72.862358,
      "State": "Maharashtra"
  },
  {
      "id": "Arcot",
      "label": "Arcot",
      "Latitude": 12.904441,
      "Longitude": 79.31916,
      "State": "Tamil Nadu"
  },
  {
      "id": "Arrah",
      "label": "Arrah",
      "Latitude": 25.556044,
      "Longitude": 84.660332,
      "State": "Bihar"
  },
  {
      "id": "Aruppukkottai",
      "label": "Aruppukkottai",
      "Latitude": 9.515625,
      "Longitude": 78.100014,
      "State": "Tamil Nadu"
  },
  {
      "id": "Arvi",
      "label": "Arvi",
      "Latitude": 20.634085,
      "Longitude": 79.140388,
      "State": "Maharashtra"
  },
  {
      "id": "Asansol",
      "label": "Asansol",
      "Latitude": 23.673944,
      "Longitude": 86.952393,
      "State": "West Bengal"
  },
  {
      "id": "Athani",
      "label": "Athani",
      "Latitude": 16.724083,
      "Longitude": 75.063843,
      "State": "Karnataka"
  },
  {
      "id": "Auraiya",
      "label": "Auraiya",
      "Latitude": 26.469999,
      "Longitude": 79.519997,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Aurangabad",
      "label": "Aurangabad",
      "Latitude": 19.901054,
      "Longitude": 75.352478,
      "State": "Maharashtra"
  },
  {
      "id": "Aurangabad",
      "label": "Aurangabad",
      "Latitude": 24.75,
      "Longitude": 84.370003,
      "State": "Bihar"
  },
  {
      "id": "Ausa",
      "label": "Ausa",
      "Latitude": 18.245655,
      "Longitude": 76.505356,
      "State": "Maharashtra"
  },
  {
      "id": "Avinashi",
      "label": "Avinashi",
      "Latitude": 11.191447,
      "Longitude": 77.268883,
      "State": "Tamil Nadu"
  },
  {
      "id": "Azamgarh",
      "label": "Azamgarh",
      "Latitude": 26.072067,
      "Longitude": 83.185654,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bagaha",
      "label": "Bagaha",
      "Latitude": 27.122196,
      "Longitude": 84.072235,
      "State": "Bihar"
  },
  {
      "id": "Bahadurgarh",
      "label": "Bahadurgarh",
      "Latitude": 28.68,
      "Longitude": 76.919998,
      "State": "Haryana"
  },
  {
      "id": "Bahraich",
      "label": "Bahraich",
      "Latitude": 27.570839,
      "Longitude": 81.598022,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Balaghat",
      "label": "Balaghat",
      "Latitude": 21.812876,
      "Longitude": 80.18383,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Balasore",
      "label": "Balasore",
      "Latitude": 21.494978,
      "Longitude": 86.942657,
      "State": "Odisha"
  },
  {
      "id": "Ballari",
      "label": "Ballari",
      "Latitude": 15.139393,
      "Longitude": 76.92144,
      "State": "Karnataka"
  },
  {
      "id": "Ballia",
      "label": "Ballia",
      "Latitude": 25.758503,
      "Longitude": 84.148911,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bally",
      "label": "Bally",
      "Latitude": 22.655149,
      "Longitude": 88.340553,
      "State": "West Bengal"
  },
  {
      "id": "Balotra",
      "label": "Balotra",
      "Latitude": 25.83087,
      "Longitude": 72.24012,
      "State": "Rajasthan"
  },
  {
      "id": "Balrampur",
      "label": "Balrampur",
      "Latitude": 27.429707,
      "Longitude": 82.176804,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Balurghat",
      "label": "Balurghat",
      "Latitude": 25.237284,
      "Longitude": 88.783058,
      "State": "West Bengal"
  },
  {
      "id": "Banda",
      "label": "Banda",
      "Latitude": 25.492249,
      "Longitude": 80.336151,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bangalore",
      "label": "Bangalore",
      "Latitude": 12.972442,
      "Longitude": 77.580643,
      "State": "Karnataka"
  },
  {
      "id": "Banka",
      "label": "Banka",
      "Latitude": 24.885483,
      "Longitude": 86.920731,
      "State": "Bihar"
  },
  {
      "id": "Bankura",
      "label": "Bankura",
      "Latitude": 23.233774,
      "Longitude": 87.08725,
      "State": "West Bengal"
  },
  {
      "id": "Banswara",
      "label": "Banswara",
      "Latitude": 23.546757,
      "Longitude": 74.43383,
      "State": "Rajasthan"
  },
  {
      "id": "Bapatla",
      "label": "Bapatla",
      "Latitude": 15.896622,
      "Longitude": 80.460434,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Barabanki",
      "label": "Barabanki",
      "Latitude": 26.937834,
      "Longitude": 81.188324,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Baramati",
      "label": "Baramati",
      "Latitude": 18.150663,
      "Longitude": 74.576782,
      "State": "Maharashtra"
  },
  {
      "id": "Baramulla",
      "label": "Baramulla",
      "Latitude": 34.202148,
      "Longitude": 74.348259,
      "State": "Jammu and Kashmir"
  },
  {
      "id": "Baran",
      "label": "Baran",
      "Latitude": 25.101145,
      "Longitude": 76.513161,
      "State": "Rajasthan"
  },
  {
      "id": "Barasat",
      "label": "Barasat",
      "Latitude": 22.726156,
      "Longitude": 88.47496,
      "State": "West Bengal"
  },
  {
      "id": "Barauda",
      "label": "Barauda",
      "Latitude": 21.191774,
      "Longitude": 81.718285,
      "State": "Chhattisgarh"
  },
  {
      "id": "Bardoli",
      "label": "Bardoli",
      "Latitude": 21.124857,
      "Longitude": 73.11261,
      "State": "Gujarat"
  },
  {
      "id": "Bareilly",
      "label": "Bareilly",
      "Latitude": 28.375694,
      "Longitude": 79.435959,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bargadi Magath",
      "label": "Bargadi Magath",
      "Latitude": 26.983795,
      "Longitude": 80.92907,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bargarh",
      "label": "Bargarh",
      "Latitude": 21.342585,
      "Longitude": 83.624199,
      "State": "Odisha"
  },
  {
      "id": "Barh",
      "label": "Barh",
      "Latitude": 25.477585,
      "Longitude": 85.709091,
      "State": "Bihar"
  },
  {
      "id": "Barjora",
      "label": "Barjora",
      "Latitude": 23.427221,
      "Longitude": 87.287018,
      "State": "West Bengal"
  },
  {
      "id": "Barrackpore",
      "label": "Barrackpore",
      "Latitude": 22.767427,
      "Longitude": 88.388344,
      "State": "West Bengal"
  },
  {
      "id": "Barwani",
      "label": "Barwani",
      "Latitude": 22.030001,
      "Longitude": 74.900002,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Basirhat",
      "label": "Basirhat",
      "Latitude": 22.657402,
      "Longitude": 88.86718,
      "State": "West Bengal"
  },
  {
      "id": "Basti",
      "label": "Basti",
      "Latitude": 26.822845,
      "Longitude": 82.763443,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Batala",
      "label": "Batala",
      "Latitude": 31.823462,
      "Longitude": 75.205063,
      "State": "Punjab"
  },
  {
      "id": "Bathinda",
      "label": "Bathinda",
      "Latitude": 30.210995,
      "Longitude": 74.945473,
      "State": "Punjab"
  },
  {
      "id": "Bazpur",
      "label": "Bazpur",
      "Latitude": 29.162411,
      "Longitude": 79.152168,
      "State": "Uttarakhand"
  },
  {
      "id": "Beawar",
      "label": "Beawar",
      "Latitude": 26.100735,
      "Longitude": 74.319077,
      "State": "Rajasthan"
  },
  {
      "id": "Beed",
      "label": "Beed",
      "Latitude": 18.992012,
      "Longitude": 75.776138,
      "State": "Maharashtra"
  },
  {
      "id": "Begusarai",
      "label": "Begusarai",
      "Latitude": 25.416676,
      "Longitude": 86.129379,
      "State": "Bihar"
  },
  {
      "id": "Bela Pratapgarh",
      "label": "Bela Pratapgarh",
      "Latitude": 25.912968,
      "Longitude": 81.991653,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Belgaum",
      "label": "Belgaum",
      "Latitude": 15.852792,
      "Longitude": 74.498703,
      "State": "Karnataka"
  },
  {
      "id": "Bellampalli",
      "label": "Bellampalli",
      "Latitude": 19.071556,
      "Longitude": 79.491173,
      "State": "Telangana"
  },
  {
      "id": "Bengaluru",
      "label": "Bengaluru",
      "Latitude": 12.971599,
      "Longitude": 77.594566,
      "State": "Karnataka"
  },
  {
      "id": "Berhampore",
      "label": "Berhampore",
      "Latitude": 24.098827,
      "Longitude": 88.267929,
      "State": "West Bengal"
  },
  {
      "id": "Bettiah",
      "label": "Bettiah",
      "Latitude": 26.799999,
      "Longitude": 84.5,
      "State": "Bihar"
  },
  {
      "id": "Bhadgaon",
      "label": "Bhadgaon",
      "Latitude": 20.666668,
      "Longitude": 75.23333,
      "State": "Maharashtra"
  },
  {
      "id": "Bhadohi",
      "label": "Bhadohi",
      "Latitude": 25.38727,
      "Longitude": 82.568031,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bhadrak",
      "label": "Bhadrak",
      "Latitude": 21.051182,
      "Longitude": 86.485748,
      "State": "Odisha"
  },
  {
      "id": "Bhadravati",
      "label": "Bhadravati",
      "Latitude": 13.84,
      "Longitude": 75.702003,
      "State": "Karnataka"
  },
  {
      "id": "Bhagalpur",
      "label": "Bhagalpur",
      "Latitude": 25.253391,
      "Longitude": 86.989059,
      "State": "Bihar"
  },
  {
      "id": "Bhandara",
      "label": "Bhandara",
      "Latitude": 21.17,
      "Longitude": 79.650002,
      "State": "Maharashtra"
  },
  {
      "id": "Bhankrota",
      "label": "Bhankrota",
      "Latitude": 26.87063,
      "Longitude": 75.693398,
      "State": "Rajasthan"
  },
  {
      "id": "Bharuch",
      "label": "Bharuch",
      "Latitude": 21.705723,
      "Longitude": 72.998199,
      "State": "Gujarat"
  },
  {
      "id": "Bhatpara",
      "label": "Bhatpara",
      "Latitude": 22.859726,
      "Longitude": 88.404839,
      "State": "West Bengal"
  },
  {
      "id": "Bhatta",
      "label": "Bhatta",
      "Latitude": 23.00795,
      "Longitude": 72.553757,
      "State": "Gujarat"
  },
  {
      "id": "Bhavani",
      "label": "Bhavani",
      "Latitude": 11.452434,
      "Longitude": 77.693253,
      "State": "Tamil Nadu"
  },
  {
      "id": "Bheemili",
      "label": "Bheemili",
      "Latitude": 17.887518,
      "Longitude": 83.445679,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Bhilwara",
      "label": "Bhilwara",
      "Latitude": 25.346251,
      "Longitude": 74.636383,
      "State": "Rajasthan"
  },
  {
      "id": "Bhimavaram",
      "label": "Bhimavaram",
      "Latitude": 16.544893,
      "Longitude": 81.52124,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Bhiwani",
      "label": "Bhiwani",
      "Latitude": 28.799046,
      "Longitude": 76.133514,
      "State": "Haryana"
  },
  {
      "id": "Bhopal",
      "label": "Bhopal",
      "Latitude": 23.259933,
      "Longitude": 77.412613,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Bhubaneswar",
      "label": "Bhubaneswar",
      "Latitude": 20.296059,
      "Longitude": 85.824539,
      "State": "Odisha"
  },
  {
      "id": "Bhubaneswar",
      "label": "Bhubaneswar",
      "Latitude": 20.296059,
      "Longitude": 85.824539,
      "State": "Odisha"
  },
  {
      "id": "Bhuj",
      "label": "Bhuj",
      "Latitude": 23.242001,
      "Longitude": 69.666931,
      "State": "Gujarat"
  },
  {
      "id": "Bhusawal",
      "label": "Bhusawal",
      "Latitude": 21.045521,
      "Longitude": 75.801094,
      "State": "Maharashtra"
  },
  {
      "id": "Bhuvanagiri",
      "label": "Bhuvanagiri",
      "Latitude": 17.518345,
      "Longitude": 78.885956,
      "State": "Telangana"
  },
  {
      "id": "Bicholim",
      "label": "Bicholim",
      "Latitude": 15.601875,
      "Longitude": 73.954636,
      "State": "Goa"
  },
  {
      "id": "Bidar",
      "label": "Bidar",
      "Latitude": 17.92,
      "Longitude": 77.519722,
      "State": "Karnataka"
  },
  {
      "id": "Bihar Sharif",
      "label": "Bihar Sharif",
      "Latitude": 25.19935,
      "Longitude": 85.517609,
      "State": "Bihar"
  },
  {
      "id": "Bihta",
      "label": "Bihta",
      "Latitude": 25.563322,
      "Longitude": 84.869804,
      "State": "Bihar"
  },
  {
      "id": "Bijapur",
      "label": "Bijapur",
      "Latitude": 16.827545,
      "Longitude": 75.725327,
      "State": "Karnataka"
  },
  {
      "id": "Bijnor",
      "label": "Bijnor",
      "Latitude": 29.372442,
      "Longitude": 78.135849,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bikaner",
      "label": "Bikaner",
      "Latitude": 28.027138,
      "Longitude": 73.302155,
      "State": "Rajasthan"
  },
  {
      "id": "Bilaspur",
      "label": "Bilaspur",
      "Latitude": 22.078642,
      "Longitude": 82.152328,
      "State": "Chhattisgarh"
  },
  {
      "id": "Bisalpur",
      "label": "Bisalpur",
      "Latitude": 28.293783,
      "Longitude": 79.804459,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bodhgaya",
      "label": "Bodhgaya",
      "Latitude": 24.696135,
      "Longitude": 84.986954,
      "State": "Bihar"
  },
  {
      "id": "Bokaro Steel label",
      "label": "Bokaro Steel label",
      "Latitude": 23.669296,
      "Longitude": 86.151115,
      "State": "Jharkhand"
  },
  {
      "id": "Bongaigaon",
      "label": "Bongaigaon",
      "Latitude": 26.500999,
      "Longitude": 90.535233,
      "State": "Assam"
  },
  {
      "id": "Bongaon",
      "label": "Bongaon",
      "Latitude": 23.07,
      "Longitude": 88.82,
      "State": "West Bengal"
  },
  {
      "id": "Borivali",
      "label": "Borivali",
      "Latitude": 19.228825,
      "Longitude": 72.854118,
      "State": "Maharashtra"
  },
  {
      "id": "Botad",
      "label": "Botad",
      "Latitude": 22.170424,
      "Longitude": 71.668427,
      "State": "Gujarat"
  },
  {
      "id": "Brahmapur",
      "label": "Brahmapur",
      "Latitude": 19.314962,
      "Longitude": 84.79409,
      "State": "Odisha"
  },
  {
      "id": "Budaun",
      "label": "Budaun",
      "Latitude": 28.033709,
      "Longitude": 79.120544,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bulandshahar",
      "label": "Bulandshahar",
      "Latitude": 28.411331,
      "Longitude": 77.848434,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Bulandshahr",
      "label": "Bulandshahr",
      "Latitude": 28.406963,
      "Longitude": 77.849831,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Buldana",
      "label": "Buldana",
      "Latitude": 20.536846,
      "Longitude": 76.18087,
      "State": "Maharashtra"
  },
  {
      "id": "Bundi",
      "label": "Bundi",
      "Latitude": 25.430513,
      "Longitude": 75.649902,
      "State": "Rajasthan"
  },
  {
      "id": "Burdwan",
      "label": "Burdwan",
      "Latitude": 23.232513,
      "Longitude": 87.863419,
      "State": "West Bengal"
  },
  {
      "id": "Burhanpur",
      "label": "Burhanpur",
      "Latitude": 21.307373,
      "Longitude": 76.230415,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Buti Bori",
      "label": "Buti Bori",
      "Latitude": 20.927933,
      "Longitude": 79.004143,
      "State": "Maharashtra"
  },
  {
      "id": "Buxar",
      "label": "Buxar",
      "Latitude": 25.564711,
      "Longitude": 83.977745,
      "State": "Bihar"
  },
  {
      "id": "Chabua",
      "label": "Chabua",
      "Latitude": 27.48,
      "Longitude": 95.18,
      "State": "Assam"
  },
  {
      "id": "Chachiyawas",
      "label": "Chachiyawas",
      "Latitude": 26.570478,
      "Longitude": 74.674438,
      "State": "Rajasthan"
  },
  {
      "id": "Chakradharpur",
      "label": "Chakradharpur",
      "Latitude": 22.668312,
      "Longitude": 85.625511,
      "State": "Jharkhand"
  },
  {
      "id": "Chalakudy",
      "label": "Chalakudy",
      "Latitude": 10.311879,
      "Longitude": 76.331978,
      "State": "Kerala"
  },
  {
      "id": "Chalisgaon",
      "label": "Chalisgaon",
      "Latitude": 20.464079,
      "Longitude": 74.996857,
      "State": "Maharashtra"
  },
  {
      "id": "Chandigarh",
      "label": "Chandigarh",
      "Latitude": 30.741482,
      "Longitude": 76.768066,
      "State": "Chandigarh"
  },
  {
      "id": "Chandrapur",
      "label": "Chandrapur",
      "Latitude": 19.970324,
      "Longitude": 79.30336,
      "State": "Maharashtra"
  },
  {
      "id": "Channapatna",
      "label": "Channapatna",
      "Latitude": 12.651805,
      "Longitude": 77.208946,
      "State": "Karnataka"
  },
  {
      "id": "Chatrapur",
      "label": "Chatrapur",
      "Latitude": 19.354979,
      "Longitude": 84.986732,
      "State": "Odisha"
  },
  {
      "id": "Chengalpattu",
      "label": "Chengalpattu",
      "Latitude": 12.693933,
      "Longitude": 79.975662,
      "State": "Tamil Nadu"
  },
  {
      "id": "Chennai",
      "label": "Chennai",
      "Latitude": 13.067439,
      "Longitude": 80.237617,
      "State": "Tamil Nadu"
  },
  {
      "id": "Chhapra",
      "label": "Chhapra",
      "Latitude": 25.779566,
      "Longitude": 84.749886,
      "State": "Bihar"
  },
  {
      "id": "Chhatarpur",
      "label": "Chhatarpur",
      "Latitude": 24.916355,
      "Longitude": 79.581184,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Chhindwara",
      "label": "Chhindwara",
      "Latitude": 22.057163,
      "Longitude": 78.938202,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Chikhli",
      "label": "Chikhli",
      "Latitude": 20.349098,
      "Longitude": 76.265289,
      "State": "Maharashtra"
  },
  {
      "id": "Chikkaballapura",
      "label": "Chikkaballapura",
      "Latitude": 13.432515,
      "Longitude": 77.727478,
      "State": "Karnataka"
  },
  {
      "id": "Chimur",
      "label": "Chimur",
      "Latitude": 20.501314,
      "Longitude": 79.380173,
      "State": "Maharashtra"
  },
  {
      "id": "Chintamani",
      "label": "Chintamani",
      "Latitude": 13.401969,
      "Longitude": 78.055138,
      "State": "Karnataka"
  },
  {
      "id": "Chiplun",
      "label": "Chiplun",
      "Latitude": 17.53231,
      "Longitude": 73.517792,
      "State": "Maharashtra"
  },
  {
      "id": "Chirala",
      "label": "Chirala",
      "Latitude": 15.812074,
      "Longitude": 80.355377,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Chirimiri",
      "label": "Chirimiri",
      "Latitude": 23.18795,
      "Longitude": 82.354164,
      "State": "Chhattisgarh"
  },
  {
      "id": "Chitradurga",
      "label": "Chitradurga",
      "Latitude": 14.23,
      "Longitude": 76.400002,
      "State": "Karnataka"
  },
  {
      "id": "Chittoor",
      "label": "Chittoor",
      "Latitude": 13.217096,
      "Longitude": 79.100677,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Chittoor",
      "label": "Chittoor",
      "Latitude": 24.888744,
      "Longitude": 74.626923,
      "State": "Rajasthan"
  },
  {
      "id": "Chittorgarh",
      "label": "Chittorgarh",
      "Latitude": 24.879999,
      "Longitude": 74.629997,
      "State": "Rajasthan"
  },
  {
      "id": "Chomu",
      "label": "Chomu",
      "Latitude": 27.17,
      "Longitude": 75.720001,
      "State": "Rajasthan"
  },
  {
      "id": "Churu",
      "label": "Churu",
      "Latitude": 28.29229,
      "Longitude": 74.966583,
      "State": "Rajasthan"
  },
  {
      "id": "Coimbatore",
      "label": "Coimbatore",
      "Latitude": 11.004556,
      "Longitude": 76.961632,
      "State": "Tamil Nadu"
  },
  {
      "id": "Coimbatore",
      "label": "Coimbatore",
      "Latitude": 11.017363,
      "Longitude": 76.958885,
      "State": "Tamil Nadu"
  },
  {
      "id": "Contai",
      "label": "Contai",
      "Latitude": 21.779188,
      "Longitude": 87.744629,
      "State": "West Bengal"
  },
  {
      "id": "Cooch Behar",
      "label": "Cooch Behar",
      "Latitude": 26.323921,
      "Longitude": 89.451088,
      "State": "West Bengal"
  },
  {
      "id": "Cuddalore",
      "label": "Cuddalore",
      "Latitude": 11.744699,
      "Longitude": 79.768021,
      "State": "Tamil Nadu"
  },
  {
      "id": "Cuttack",
      "label": "Cuttack",
      "Latitude": 20.462521,
      "Longitude": 85.882988,
      "State": "Odisha"
  },
  {
      "id": "DCKAP Technologies",
      "label": "DCKAP Technologies",
      "Latitude": 13.090994,
      "Longitude": 80.224998,
      "State": "Tamil Nadu"
  },
  {
      "id": "Dadabari",
      "label": "Dadabari",
      "Latitude": 25.155169,
      "Longitude": 75.827248,
      "State": "Rajasthan"
  },
  {
      "id": "Dadri",
      "label": "Dadri",
      "Latitude": 28.54619,
      "Longitude": 77.556213,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Dahanu",
      "label": "Dahanu",
      "Latitude": 19.990751,
      "Longitude": 72.743675,
      "State": "Maharashtra"
  },
  {
      "id": "Dahod",
      "label": "Dahod",
      "Latitude": 22.835602,
      "Longitude": 74.255989,
      "State": "Gujarat"
  },
  {
      "id": "Dalkhola",
      "label": "Dalkhola",
      "Latitude": 25.874945,
      "Longitude": 87.845551,
      "State": "West Bengal"
  },
  {
      "id": "Daman",
      "label": "Daman",
      "Latitude": 20.397373,
      "Longitude": 72.832802,
      "State": "Daman and Diu"
  },
  {
      "id": "Damoh",
      "label": "Damoh",
      "Latitude": 23.839054,
      "Longitude": 79.441025,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Dankuni",
      "label": "Dankuni",
      "Latitude": 22.671679,
      "Longitude": 88.300209,
      "State": "West Bengal"
  },
  {
      "id": "Darbhanga",
      "label": "Darbhanga",
      "Latitude": 26.152973,
      "Longitude": 85.901413,
      "State": "Bihar"
  },
  {
      "id": "Darjeeling",
      "label": "Darjeeling",
      "Latitude": 27.036007,
      "Longitude": 88.262672,
      "State": "West Bengal"
  },
  {
      "id": "Daryapur",
      "label": "Daryapur",
      "Latitude": 20.92207,
      "Longitude": 77.326698,
      "State": "Maharashtra"
  },
  {
      "id": "Datia",
      "label": "Datia",
      "Latitude": 25.665325,
      "Longitude": 78.460938,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Dausa",
      "label": "Dausa",
      "Latitude": 26.894478,
      "Longitude": 76.334824,
      "State": "Rajasthan"
  },
  {
      "id": "Davanagere",
      "label": "Davanagere",
      "Latitude": 14.464103,
      "Longitude": 75.921661,
      "State": "Karnataka"
  },
  {
      "id": "Davangere",
      "label": "Davangere",
      "Latitude": 14.470586,
      "Longitude": 75.914154,
      "State": "Karnataka"
  },
  {
      "id": "Debra",
      "label": "Debra",
      "Latitude": 22.369043,
      "Longitude": 87.55442,
      "State": "West Bengal"
  },
  {
      "id": "Deesa",
      "label": "Deesa",
      "Latitude": 24.258503,
      "Longitude": 72.190674,
      "State": "Gujarat"
  },
  {
      "id": "Dehradun",
      "label": "Dehradun",
      "Latitude": 30.316496,
      "Longitude": 78.032188,
      "State": "Uttarakhand"
  },
  {
      "id": "Delhi",
      "label": "Delhi",
      "Latitude": 28.679079,
      "Longitude": 77.06971,
      "State": "Delhi"
  },
  {
      "id": "Deoghar",
      "label": "Deoghar",
      "Latitude": 24.482775,
      "Longitude": 86.695175,
      "State": "Jharkhand"
  },
  {
      "id": "Devlali",
      "label": "Devlali",
      "Latitude": 19.906166,
      "Longitude": 73.824265,
      "State": "Maharashtra"
  },
  {
      "id": "Dewas",
      "label": "Dewas",
      "Latitude": 22.962267,
      "Longitude": 76.050797,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Dhampur",
      "label": "Dhampur",
      "Latitude": 29.257648,
      "Longitude": 78.500061,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Dhamtari",
      "label": "Dhamtari",
      "Latitude": 20.709999,
      "Longitude": 81.550003,
      "State": "Chhattisgarh"
  },
  {
      "id": "Dhanbad",
      "label": "Dhanbad",
      "Latitude": 23.795399,
      "Longitude": 86.42704,
      "State": "Jharkhand"
  },
  {
      "id": "Dhanpur",
      "label": "Dhanpur",
      "Latitude": 22.633492,
      "Longitude": 74.095993,
      "State": "Gujarat"
  },
  {
      "id": "Dhanpuri",
      "label": "Dhanpuri",
      "Latitude": 23.173939,
      "Longitude": 81.565125,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Dhar",
      "label": "Dhar",
      "Latitude": 22.601292,
      "Longitude": 75.302467,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Dharampur",
      "label": "Dharampur",
      "Latitude": 20.54014,
      "Longitude": 73.179214,
      "State": "Gujarat"
  },
  {
      "id": "Dharavi",
      "label": "Dharavi",
      "Latitude": 19.044218,
      "Longitude": 72.85598,
      "State": "Maharashtra"
  },
  {
      "id": "Dharmavaram",
      "label": "Dharmavaram",
      "Latitude": 14.413745,
      "Longitude": 77.712616,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Dharwad",
      "label": "Dharwad",
      "Latitude": 15.460252,
      "Longitude": 75.010284,
      "State": "Karnataka"
  },
  {
      "id": "Dhayari",
      "label": "Dhayari",
      "Latitude": 18.441833,
      "Longitude": 73.812157,
      "State": "Maharashtra"
  },
  {
      "id": "Dhenkanal",
      "label": "Dhenkanal",
      "Latitude": 20.660671,
      "Longitude": 85.596954,
      "State": "Odisha"
  },
  {
      "id": "Dholpur",
      "label": "Dholpur",
      "Latitude": 26.702518,
      "Longitude": 77.893394,
      "State": "Rajasthan"
  },
  {
      "id": "Dhule",
      "label": "Dhule",
      "Latitude": 20.903118,
      "Longitude": 74.774986,
      "State": "Maharashtra"
  },
  {
      "id": "Dhuri",
      "label": "Dhuri",
      "Latitude": 30.370001,
      "Longitude": 75.870003,
      "State": "Punjab"
  },
  {
      "id": "Dibrugarh",
      "label": "Dibrugarh",
      "Latitude": 27.472834,
      "Longitude": 94.911964,
      "State": "Assam"
  },
  {
      "id": "Dimapur",
      "label": "Dimapur",
      "Latitude": 25.906267,
      "Longitude": 93.727592,
      "State": "Nagaland"
  },
  {
      "id": "Dindigul",
      "label": "Dindigul",
      "Latitude": 10.365581,
      "Longitude": 77.970657,
      "State": "Tamil Nadu"
  },
  {
      "id": "Doddaballapura",
      "label": "Doddaballapura",
      "Latitude": 13.298757,
      "Longitude": 77.540817,
      "State": "Karnataka"
  },
  {
      "id": "Dombivli",
      "label": "Dombivli",
      "Latitude": 19.2094,
      "Longitude": 73.093948,
      "State": "Maharashtra"
  },
  {
      "id": "Domchanch",
      "label": "Domchanch",
      "Latitude": 24.47438,
      "Longitude": 85.688744,
      "State": "Jharkhand"
  },
  {
      "id": "Dungargarh",
      "label": "Dungargarh",
      "Latitude": 28.095606,
      "Longitude": 74.011116,
      "State": "Rajasthan"
  },
  {
      "id": "Durg",
      "label": "Durg",
      "Latitude": 21.190449,
      "Longitude": 81.28492,
      "State": "Chhattisgarh"
  },
  {
      "id": "Durgapur",
      "label": "Durgapur",
      "Latitude": 23.53344,
      "Longitude": 87.32193,
      "State": "West Bengal"
  },
  {
      "id": "Dwarka",
      "label": "Dwarka",
      "Latitude": 28.59214,
      "Longitude": 77.046051,
      "State": "Delhi"
  },
  {
      "id": "Egra",
      "label": "Egra",
      "Latitude": 21.900526,
      "Longitude": 87.538078,
      "State": "West Bengal"
  },
  {
      "id": "Ejipura",
      "label": "Ejipura",
      "Latitude": 12.942621,
      "Longitude": 77.627121,
      "State": "Karnataka"
  },
  {
      "id": "Eluru",
      "label": "Eluru",
      "Latitude": 16.703285,
      "Longitude": 81.100388,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Ennore",
      "label": "Ennore",
      "Latitude": 13.206524,
      "Longitude": 80.327225,
      "State": "Tamil Nadu"
  },
  {
      "id": "Erode",
      "label": "Erode",
      "Latitude": 11.342423,
      "Longitude": 77.728165,
      "State": "Tamil Nadu"
  },
  {
      "id": "Etah",
      "label": "Etah",
      "Latitude": 27.55875,
      "Longitude": 78.662567,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Etawah",
      "label": "Etawah",
      "Latitude": 26.811712,
      "Longitude": 79.004692,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Faizabad",
      "label": "Faizabad",
      "Latitude": 26.77,
      "Longitude": 82.150002,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Falta",
      "label": "Falta",
      "Latitude": 22.296404,
      "Longitude": 88.120995,
      "State": "West Bengal"
  },
  {
      "id": "Faridkot",
      "label": "Faridkot",
      "Latitude": 30.678186,
      "Longitude": 74.739555,
      "State": "Punjab"
  },
  {
      "id": "Farrukhabad",
      "label": "Farrukhabad",
      "Latitude": 27.387049,
      "Longitude": 79.588127,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Fatehabad",
      "label": "Fatehabad",
      "Latitude": 29.511778,
      "Longitude": 75.455215,
      "State": "Haryana"
  },
  {
      "id": "Fatehpur",
      "label": "Fatehpur",
      "Latitude": 25.920074,
      "Longitude": 80.809998,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Fatehpur",
      "label": "Fatehpur",
      "Latitude": 27.99502,
      "Longitude": 74.961792,
      "State": "Rajasthan"
  },
  {
      "id": "Fazilka",
      "label": "Fazilka",
      "Latitude": 30.403648,
      "Longitude": 74.027962,
      "State": "Punjab"
  },
  {
      "id": "Ferozepur",
      "label": "Ferozepur",
      "Latitude": 30.923433,
      "Longitude": 74.610214,
      "State": "Punjab"
  },
  {
      "id": "Firozabad",
      "label": "Firozabad",
      "Latitude": 27.159101,
      "Longitude": 78.39576,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Forbesganj",
      "label": "Forbesganj",
      "Latitude": 26.298552,
      "Longitude": 87.265388,
      "State": "Bihar"
  },
  {
      "id": "Ganderbal",
      "label": "Ganderbal",
      "Latitude": 34.216496,
      "Longitude": 74.771942,
      "State": "Jammu and Kashmir"
  },
  {
      "id": "Gandhinagar",
      "label": "Gandhinagar",
      "Latitude": 23.23756,
      "Longitude": 72.647781,
      "State": "Gujarat"
  },
  {
      "id": "Gangakhed",
      "label": "Gangakhed",
      "Latitude": 18.966354,
      "Longitude": 76.748077,
      "State": "Maharashtra"
  },
  {
      "id": "Gangtok",
      "label": "Gangtok",
      "Latitude": 27.338936,
      "Longitude": 88.606506,
      "State": "Sikkim"
  },
  {
      "id": "Gannavaram",
      "label": "Gannavaram",
      "Latitude": 16.538591,
      "Longitude": 80.798218,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Garhshankar",
      "label": "Garhshankar",
      "Latitude": 31.213682,
      "Longitude": 76.144012,
      "State": "Punjab"
  },
  {
      "id": "Gauribidanur",
      "label": "Gauribidanur",
      "Latitude": 13.611159,
      "Longitude": 77.51696,
      "State": "Karnataka"
  },
  {
      "id": "Gaya",
      "label": "Gaya",
      "Latitude": 24.78001,
      "Longitude": 84.981827,
      "State": "Bihar"
  },
  {
      "id": "Georai",
      "label": "Georai",
      "Latitude": 19.263334,
      "Longitude": 75.752426,
      "State": "Maharashtra"
  },
  {
      "id": "Ghansoli",
      "label": "Ghansoli",
      "Latitude": 19.125362,
      "Longitude": 72.999199,
      "State": "Maharashtra"
  },
  {
      "id": "Ghatal",
      "label": "Ghatal",
      "Latitude": 22.663696,
      "Longitude": 87.746803,
      "State": "West Bengal"
  },
  {
      "id": "Ghatampur",
      "label": "Ghatampur",
      "Latitude": 26.147612,
      "Longitude": 80.170769,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Ghatampur",
      "label": "Ghatampur",
      "Latitude": 26.164066,
      "Longitude": 80.17067,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Ghaziabad",
      "label": "Ghaziabad",
      "Latitude": 28.667856,
      "Longitude": 77.449791,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Ghazipur",
      "label": "Ghazipur",
      "Latitude": 25.584042,
      "Longitude": 83.577019,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Gingee",
      "label": "Gingee",
      "Latitude": 12.252576,
      "Longitude": 79.416924,
      "State": "Tamil Nadu"
  },
  {
      "id": "Giridih",
      "label": "Giridih",
      "Latitude": 24.184713,
      "Longitude": 86.302193,
      "State": "Jharkhand"
  },
  {
      "id": "Godda",
      "label": "Godda",
      "Latitude": 24.827778,
      "Longitude": 87.211388,
      "State": "Jharkhand"
  },
  {
      "id": "Gohana",
      "label": "Gohana",
      "Latitude": 29.138407,
      "Longitude": 76.693245,
      "State": "Haryana"
  },
  {
      "id": "Gohpur",
      "label": "Gohpur",
      "Latitude": 26.880077,
      "Longitude": 93.60833,
      "State": "Assam"
  },
  {
      "id": "Gokak",
      "label": "Gokak",
      "Latitude": 16.1667,
      "Longitude": 74.833298,
      "State": "Karnataka"
  },
  {
      "id": "Gola Gokarannath",
      "label": "Gola Gokarannath",
      "Latitude": 28.078636,
      "Longitude": 80.471588,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Gola Gokrannath Kheri",
      "label": "Gola Gokrannath Kheri",
      "Latitude": 28.080379,
      "Longitude": 80.466644,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Gonda",
      "label": "Gonda",
      "Latitude": 27.133875,
      "Longitude": 81.96199,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Gondal",
      "label": "Gondal",
      "Latitude": 21.961946,
      "Longitude": 70.792297,
      "State": "Gujarat"
  },
  {
      "id": "Gondia",
      "label": "Gondia",
      "Latitude": 21.459801,
      "Longitude": 80.195,
      "State": "Maharashtra"
  },
  {
      "id": "Gorakhpur",
      "label": "Gorakhpur",
      "Latitude": 26.765844,
      "Longitude": 83.364944,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Goregaon",
      "label": "Goregaon",
      "Latitude": 19.155001,
      "Longitude": 72.849998,
      "State": "Maharashtra"
  },
  {
      "id": "Greater Noida",
      "label": "Greater Noida",
      "Latitude": 28.474388,
      "Longitude": 77.50399,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Gudur",
      "label": "Gudur",
      "Latitude": 14.146319,
      "Longitude": 79.850388,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Gumla",
      "label": "Gumla",
      "Latitude": 23.041924,
      "Longitude": 84.540833,
      "State": "Jharkhand"
  },
  {
      "id": "Guna",
      "label": "Guna",
      "Latitude": 24.65,
      "Longitude": 77.32,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Guntakal",
      "label": "Guntakal",
      "Latitude": 15.167409,
      "Longitude": 77.373627,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Guntur",
      "label": "Guntur",
      "Latitude": 16.314209,
      "Longitude": 80.435028,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Gurdaspur",
      "label": "Gurdaspur",
      "Latitude": 32.041943,
      "Longitude": 75.405334,
      "State": "Punjab"
  },
  {
      "id": "Gurgaon",
      "label": "Gurgaon",
      "Latitude": 28.457523,
      "Longitude": 77.026344,
      "State": "Haryana"
  },
  {
      "id": "Guwahati",
      "label": "Guwahati",
      "Latitude": 26.148043,
      "Longitude": 91.731377,
      "State": "Assam"
  },
  {
      "id": "Gwalior",
      "label": "Gwalior",
      "Latitude": 26.218287,
      "Longitude": 78.182831,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Hailakandi",
      "label": "Hailakandi",
      "Latitude": 24.68469,
      "Longitude": 92.564339,
      "State": "Assam"
  },
  {
      "id": "Hajipur",
      "label": "Hajipur",
      "Latitude": 25.68,
      "Longitude": 85.220001,
      "State": "Bihar"
  },
  {
      "id": "Haldia",
      "label": "Haldia",
      "Latitude": 22.066673,
      "Longitude": 88.069809,
      "State": "West Bengal"
  },
  {
      "id": "Haldwani",
      "label": "Haldwani",
      "Latitude": 29.219677,
      "Longitude": 79.512459,
      "State": "Uttarakhand"
  },
  {
      "id": "Halol",
      "label": "Halol",
      "Latitude": 22.496063,
      "Longitude": 73.475449,
      "State": "Gujarat"
  },
  {
      "id": "Hanamkonda",
      "label": "Hanamkonda",
      "Latitude": 18.007202,
      "Longitude": 79.558296,
      "State": "Telangana"
  },
  {
      "id": "Hansi",
      "label": "Hansi",
      "Latitude": 29.102377,
      "Longitude": 75.965996,
      "State": "Haryana"
  },
  {
      "id": "Hanumangarh",
      "label": "Hanumangarh",
      "Latitude": 29.625996,
      "Longitude": 74.287491,
      "State": "Rajasthan"
  },
  {
      "id": "Hapur",
      "label": "Hapur",
      "Latitude": 28.730579,
      "Longitude": 77.775879,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Harda",
      "label": "Harda",
      "Latitude": 22.356426,
      "Longitude": 77.102737,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Haridwar",
      "label": "Haridwar",
      "Latitude": 29.94569,
      "Longitude": 78.164246,
      "State": "Uttarakhand"
  },
  {
      "id": "Harihar",
      "label": "Harihar",
      "Latitude": 14.530457,
      "Longitude": 75.801094,
      "State": "Karnataka"
  },
  {
      "id": "Haringhata",
      "label": "Haringhata",
      "Latitude": 22.96051,
      "Longitude": 88.567406,
      "State": "West Bengal"
  },
  {
      "id": "Harnaut",
      "label": "Harnaut",
      "Latitude": 25.369179,
      "Longitude": 85.53006,
      "State": "Bihar"
  },
  {
      "id": "Hasanpur",
      "label": "Hasanpur",
      "Latitude": 28.719999,
      "Longitude": 78.279999,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Hassan",
      "label": "Hassan",
      "Latitude": 13.009711,
      "Longitude": 76.102898,
      "State": "Karnataka"
  },
  {
      "id": "Hathras",
      "label": "Hathras",
      "Latitude": 27.6,
      "Longitude": 78.050003,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Hazaribagh",
      "label": "Hazaribagh",
      "Latitude": 23.99662,
      "Longitude": 85.36911,
      "State": "Jharkhand"
  },
  {
      "id": "Hazira",
      "label": "Hazira",
      "Latitude": 21.116226,
      "Longitude": 72.651802,
      "State": "Gujarat"
  },
  {
      "id": "Himmatnagar",
      "label": "Himmatnagar",
      "Latitude": 23.597969,
      "Longitude": 72.969818,
      "State": "Gujarat"
  },
  {
      "id": "Hindaun label",
      "label": "Hindaun label",
      "Latitude": 26.731142,
      "Longitude": 77.033752,
      "State": "Rajasthan"
  },
  {
      "id": "Hinganghat",
      "label": "Hinganghat",
      "Latitude": 20.550573,
      "Longitude": 78.841141,
      "State": "Maharashtra"
  },
  {
      "id": "Hisar",
      "label": "Hisar",
      "Latitude": 29.151861,
      "Longitude": 75.721123,
      "State": "Haryana"
  },
  {
      "id": "Hodal",
      "label": "Hodal",
      "Latitude": 27.897551,
      "Longitude": 77.384117,
      "State": "Haryana"
  },
  {
      "id": "Hojai",
      "label": "Hojai",
      "Latitude": 26.006807,
      "Longitude": 92.866402,
      "State": "Assam"
  },
  {
      "id": "Hoshangabad",
      "label": "Hoshangabad",
      "Latitude": 22.744108,
      "Longitude": 77.736969,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Hoshiarpur",
      "label": "Hoshiarpur",
      "Latitude": 31.527355,
      "Longitude": 75.913673,
      "State": "Punjab"
  },
  {
      "id": "Hoskote",
      "label": "Hoskote",
      "Latitude": 13.07,
      "Longitude": 77.800003,
      "State": "Karnataka"
  },
  {
      "id": "Hosur",
      "label": "Hosur",
      "Latitude": 12.735126,
      "Longitude": 77.829338,
      "State": "Tamil Nadu"
  },
  {
      "id": "Hubballi",
      "label": "Hubballi",
      "Latitude": 15.364708,
      "Longitude": 75.123955,
      "State": "Karnataka"
  },
  {
      "id": "Hubli",
      "label": "Hubli",
      "Latitude": 15.371598,
      "Longitude": 75.101166,
      "State": "Karnataka"
  },
  {
      "id": "Huliyar",
      "label": "Huliyar",
      "Latitude": 13.583274,
      "Longitude": 76.540154,
      "State": "Karnataka"
  },
  {
      "id": "Hyderabad",
      "label": "Hyderabad",
      "Latitude": 17.38714,
      "Longitude": 78.491684,
      "State": "Telangana"
  },
  {
      "id": "Ichalkaranji",
      "label": "Ichalkaranji",
      "Latitude": 16.709002,
      "Longitude": 74.456078,
      "State": "Maharashtra"
  },
  {
      "id": "Imphal",
      "label": "Imphal",
      "Latitude": 24.813967,
      "Longitude": 93.950279,
      "State": "Manipur"
  },
  {
      "id": "Indapur",
      "label": "Indapur",
      "Latitude": 18.11714,
      "Longitude": 75.023918,
      "State": "Maharashtra"
  },
  {
      "id": "Indore",
      "label": "Indore",
      "Latitude": 22.719568,
      "Longitude": 75.857727,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Islampur",
      "label": "Islampur",
      "Latitude": 26.266701,
      "Longitude": 88.199997,
      "State": "West Bengal"
  },
  {
      "id": "Jabalpur",
      "label": "Jabalpur",
      "Latitude": 23.185884,
      "Longitude": 79.97438,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Jadugora",
      "label": "Jadugora",
      "Latitude": 22.656015,
      "Longitude": 86.352882,
      "State": "Jharkhand"
  },
  {
      "id": "Jagadhri",
      "label": "Jagadhri",
      "Latitude": 30.172716,
      "Longitude": 77.299492,
      "State": "Haryana"
  },
  {
      "id": "Jagdalpur",
      "label": "Jagdalpur",
      "Latitude": 19.07,
      "Longitude": 82.029999,
      "State": "Chhattisgarh"
  },
  {
      "id": "Jagraon",
      "label": "Jagraon",
      "Latitude": 30.780001,
      "Longitude": 75.480003,
      "State": "Punjab"
  },
  {
      "id": "Jagtial",
      "label": "Jagtial",
      "Latitude": 18.794905,
      "Longitude": 78.912872,
      "State": "Telangana"
  },
  {
      "id": "Jahanabad",
      "label": "Jahanabad",
      "Latitude": 25.213928,
      "Longitude": 84.989555,
      "State": "Bihar"
  },
  {
      "id": "Jaipatna",
      "label": "Jaipatna",
      "Latitude": 19.482777,
      "Longitude": 82.806702,
      "State": "Odisha"
  },
  {
      "id": "Jaipur",
      "label": "Jaipur",
      "Latitude": 26.92207,
      "Longitude": 75.778885,
      "State": "Rajasthan"
  },
  {
      "id": "Jaisalmer",
      "label": "Jaisalmer",
      "Latitude": 26.911661,
      "Longitude": 70.922928,
      "State": "Rajasthan"
  },
  {
      "id": "Jalandhar",
      "label": "Jalandhar",
      "Latitude": 31.326015,
      "Longitude": 75.57618,
      "State": "Punjab"
  },
  {
      "id": "Jalaun",
      "label": "Jalaun",
      "Latitude": 26.140644,
      "Longitude": 79.355621,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Jalgaon Jamod",
      "label": "Jalgaon Jamod",
      "Latitude": 21.04954,
      "Longitude": 76.532028,
      "State": "Maharashtra"
  },
  {
      "id": "Jalgaon",
      "label": "Jalgaon",
      "Latitude": 21.004194,
      "Longitude": 75.563942,
      "State": "Maharashtra"
  },
  {
      "id": "Jalna",
      "label": "Jalna",
      "Latitude": 19.846811,
      "Longitude": 75.890633,
      "State": "Maharashtra"
  },
  {
      "id": "Jalpaiguri",
      "label": "Jalpaiguri",
      "Latitude": 26.540457,
      "Longitude": 88.719391,
      "State": "West Bengal"
  },
  {
      "id": "Jalukbari",
      "label": "Jalukbari",
      "Latitude": 26.144358,
      "Longitude": 91.642067,
      "State": "Assam"
  },
  {
      "id": "Jamalpur",
      "label": "Jamalpur",
      "Latitude": 23.061089,
      "Longitude": 87.992584,
      "State": "West Bengal"
  },
  {
      "id": "Jamalpur",
      "label": "Jamalpur",
      "Latitude": 25.312717,
      "Longitude": 86.490608,
      "State": "Bihar"
  },
  {
      "id": "Jamkhandi",
      "label": "Jamkhandi",
      "Latitude": 16.504227,
      "Longitude": 75.290932,
      "State": "Karnataka"
  },
  {
      "id": "Jammu",
      "label": "Jammu",
      "Latitude": 32.732998,
      "Longitude": 74.864273,
      "State": "Jammu and Kashmir"
  },
  {
      "id": "Jamnagar",
      "label": "Jamnagar",
      "Latitude": 22.470701,
      "Longitude": 70.057732,
      "State": "Gujarat"
  },
  {
      "id": "Jamner",
      "label": "Jamner",
      "Latitude": 20.809378,
      "Longitude": 75.778923,
      "State": "Maharashtra"
  },
  {
      "id": "Jamshedpur",
      "label": "Jamshedpur",
      "Latitude": 22.805618,
      "Longitude": 86.20311,
      "State": "Jharkhand"
  },
  {
      "id": "Jamui",
      "label": "Jamui",
      "Latitude": 24.92,
      "Longitude": 86.220001,
      "State": "Bihar"
  },
  {
      "id": "Jaora",
      "label": "Jaora",
      "Latitude": 23.644524,
      "Longitude": 75.131035,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Jaunpur",
      "label": "Jaunpur",
      "Latitude": 25.748695,
      "Longitude": 82.698441,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Jaysingpur",
      "label": "Jaysingpur",
      "Latitude": 16.779877,
      "Longitude": 74.556374,
      "State": "Maharashtra"
  },
  {
      "id": "Jetpur",
      "label": "Jetpur",
      "Latitude": 21.761524,
      "Longitude": 70.627625,
      "State": "Gujarat"
  },
  {
      "id": "Jhagadia",
      "label": "Jhagadia",
      "Latitude": 21.719477,
      "Longitude": 73.151009,
      "State": "Gujarat"
  },
  {
      "id": "Jhalawar",
      "label": "Jhalawar",
      "Latitude": 24.597349,
      "Longitude": 76.16098,
      "State": "Rajasthan"
  },
  {
      "id": "Jhansi",
      "label": "Jhansi",
      "Latitude": 25.436298,
      "Longitude": 78.567352,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Jharia",
      "label": "Jharia",
      "Latitude": 23.742628,
      "Longitude": 86.41114,
      "State": "Jharkhand"
  },
  {
      "id": "Jharsuguda",
      "label": "Jharsuguda",
      "Latitude": 21.85,
      "Longitude": 84.029999,
      "State": "Odisha"
  },
  {
      "id": "Jhunjhunu",
      "label": "Jhunjhunu",
      "Latitude": 28.128876,
      "Longitude": 75.399506,
      "State": "Rajasthan"
  },
  {
      "id": "Jind",
      "label": "Jind",
      "Latitude": 29.316668,
      "Longitude": 76.316666,
      "State": "Haryana"
  },
  {
      "id": "Jodhpur",
      "label": "Jodhpur",
      "Latitude": 26.263863,
      "Longitude": 73.008957,
      "State": "Rajasthan"
  },
  {
      "id": "Jorapokhar",
      "label": "Jorapokhar",
      "Latitude": 22.422455,
      "Longitude": 85.760651,
      "State": "Jharkhand"
  },
  {
      "id": "Jorhat",
      "label": "Jorhat",
      "Latitude": 26.757874,
      "Longitude": 94.209824,
      "State": "Assam"
  },
  {
      "id": "Julana",
      "label": "Julana",
      "Latitude": 29.121574,
      "Longitude": 76.39772,
      "State": "Haryana"
  },
  {
      "id": "Junagadh",
      "label": "Junagadh",
      "Latitude": 21.515471,
      "Longitude": 70.456444,
      "State": "Gujarat"
  },
  {
      "id": "Junnar",
      "label": "Junnar",
      "Latitude": 19.206861,
      "Longitude": 73.875801,
      "State": "Maharashtra"
  },
  {
      "id": "Junnar",
      "label": "Junnar",
      "Latitude": 19.20928,
      "Longitude": 73.872589,
      "State": "Maharashtra"
  },
  {
      "id": "Kadapa",
      "label": "Kadapa",
      "Latitude": 14.477234,
      "Longitude": 78.804932,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Kadayanallur",
      "label": "Kadayanallur",
      "Latitude": 9.077854,
      "Longitude": 77.345184,
      "State": "Tamil Nadu"
  },
  {
      "id": "Kadi",
      "label": "Kadi",
      "Latitude": 23.29785,
      "Longitude": 72.331001,
      "State": "Gujarat"
  },
  {
      "id": "Kadiri",
      "label": "Kadiri",
      "Latitude": 14.117532,
      "Longitude": 78.15509,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Kajamalai",
      "label": "Kajamalai",
      "Latitude": 10.775632,
      "Longitude": 78.69236,
      "State": "Tamil Nadu"
  },
  {
      "id": "Kakinada",
      "label": "Kakinada",
      "Latitude": 16.989065,
      "Longitude": 82.247467,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Kalaburagi",
      "label": "Kalaburagi",
      "Latitude": 17.320486,
      "Longitude": 76.839752,
      "State": "Karnataka"
  },
  {
      "id": "Kalaigaon",
      "label": "Kalaigaon",
      "Latitude": 26.57448,
      "Longitude": 91.975243,
      "State": "Assam"
  },
  {
      "id": "Kalamassery",
      "label": "Kalamassery",
      "Latitude": 10.051969,
      "Longitude": 76.315773,
      "State": "Kerala"
  },
  {
      "id": "Kalol",
      "label": "Kalol",
      "Latitude": 22.606001,
      "Longitude": 73.462997,
      "State": "Gujarat"
  },
  {
      "id": "Kalwan",
      "label": "Kalwan",
      "Latitude": 20.492281,
      "Longitude": 74.026009,
      "State": "Maharashtra"
  },
  {
      "id": "Kalyan",
      "label": "Kalyan",
      "Latitude": 19.242439,
      "Longitude": 73.120193,
      "State": "Maharashtra"
  },
  {
      "id": "Kamptee",
      "label": "Kamptee",
      "Latitude": 21.207769,
      "Longitude": 79.184052,
      "State": "Maharashtra"
  },
  {
      "id": "Kanchipuram",
      "label": "Kanchipuram",
      "Latitude": 12.834174,
      "Longitude": 79.703644,
      "State": "Tamil Nadu"
  },
  {
      "id": "Kanchrapara",
      "label": "Kanchrapara",
      "Latitude": 22.94923,
      "Longitude": 88.420921,
      "State": "West Bengal"
  },
  {
      "id": "Kandi",
      "label": "Kandi",
      "Latitude": 23.9468,
      "Longitude": 88.049713,
      "State": "West Bengal"
  },
  {
      "id": "Kannauj",
      "label": "Kannauj",
      "Latitude": 27.055189,
      "Longitude": 79.918083,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Kannur",
      "label": "Kannur",
      "Latitude": 11.874477,
      "Longitude": 75.370369,
      "State": "Kerala"
  },
  {
      "id": "Kanpur",
      "label": "Kanpur",
      "Latitude": 26.449923,
      "Longitude": 80.331871,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Kapurthala",
      "label": "Kapurthala",
      "Latitude": 31.379999,
      "Longitude": 75.379997,
      "State": "Punjab"
  },
  {
      "id": "Karad",
      "label": "Karad",
      "Latitude": 17.286501,
      "Longitude": 74.181427,
      "State": "Maharashtra"
  },
  {
      "id": "Karaikal",
      "label": "Karaikal",
      "Latitude": 10.92544,
      "Longitude": 79.838005,
      "State": "Puducherry"
  },
  {
      "id": "Karera",
      "label": "Karera",
      "Latitude": 25.454794,
      "Longitude": 78.133957,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Kargil",
      "label": "Kargil",
      "Latitude": 34.556335,
      "Longitude": 76.132507,
      "State": "Jammu and Kashmir"
  },
  {
      "id": "Karimnagar",
      "label": "Karimnagar",
      "Latitude": 18.438555,
      "Longitude": 79.128838,
      "State": "Telangana"
  },
  {
      "id": "Karjat",
      "label": "Karjat",
      "Latitude": 18.920902,
      "Longitude": 73.323097,
      "State": "Maharashtra"
  },
  {
      "id": "Karnal",
      "label": "Karnal",
      "Latitude": 29.685629,
      "Longitude": 76.990547,
      "State": "Haryana"
  },
  {
      "id": "Karwar",
      "label": "Karwar",
      "Latitude": 14.801439,
      "Longitude": 74.124069,
      "State": "Karnataka"
  },
  {
      "id": "Kashipur",
      "label": "Kashipur",
      "Latitude": 29.210421,
      "Longitude": 78.96183,
      "State": "Uttarakhand"
  },
  {
      "id": "Katihar",
      "label": "Katihar",
      "Latitude": 25.533508,
      "Longitude": 87.583748,
      "State": "Bihar"
  },
  {
      "id": "Katni",
      "label": "Katni",
      "Latitude": 23.833717,
      "Longitude": 80.420609,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Katraj",
      "label": "Katraj",
      "Latitude": 18.445089,
      "Longitude": 73.86898,
      "State": "Maharashtra"
  },
  {
      "id": "Kattuvilai",
      "label": "Kattuvilai",
      "Latitude": 8.158933,
      "Longitude": 77.336746,
      "State": "Tamil Nadu"
  },
  {
      "id": "Kavali",
      "label": "Kavali",
      "Latitude": 14.913181,
      "Longitude": 79.992981,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Kavathe Mahankal",
      "label": "Kavathe Mahankal",
      "Latitude": 17.006298,
      "Longitude": 74.865372,
      "State": "Maharashtra"
  },
  {
      "id": "Kavesar",
      "label": "Kavesar",
      "Latitude": 19.262466,
      "Longitude": 72.974106,
      "State": "Maharashtra"
  },
  {
      "id": "Kawardha",
      "label": "Kawardha",
      "Latitude": 22.008951,
      "Longitude": 81.224342,
      "State": "Chhattisgarh"
  },
  {
      "id": "Kekri",
      "label": "Kekri",
      "Latitude": 25.973787,
      "Longitude": 75.151535,
      "State": "Rajasthan"
  },
  {
      "id": "Khadki",
      "label": "Khadki",
      "Latitude": 18.569937,
      "Longitude": 73.850639,
      "State": "Maharashtra"
  },
  {
      "id": "Khalapur",
      "label": "Khalapur",
      "Latitude": 18.834003,
      "Longitude": 73.288712,
      "State": "Maharashtra"
  },
  {
      "id": "Khambhat",
      "label": "Khambhat",
      "Latitude": 22.318083,
      "Longitude": 72.618988,
      "State": "Gujarat"
  },
  {
      "id": "Khamgaon",
      "label": "Khamgaon",
      "Latitude": 20.711622,
      "Longitude": 76.566132,
      "State": "Maharashtra"
  },
  {
      "id": "Khammam",
      "label": "Khammam",
      "Latitude": 17.247253,
      "Longitude": 80.151443,
      "State": "Telangana"
  },
  {
      "id": "Khandwa",
      "label": "Khandwa",
      "Latitude": 21.825733,
      "Longitude": 76.35257,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Khanna",
      "label": "Khanna",
      "Latitude": 30.702877,
      "Longitude": 76.220222,
      "State": "Punjab"
  },
  {
      "id": "Kharagpur",
      "label": "Kharagpur",
      "Latitude": 22.34601,
      "Longitude": 87.231972,
      "State": "West Bengal"
  },
  {
      "id": "Kharar",
      "label": "Kharar",
      "Latitude": 30.751278,
      "Longitude": 76.637192,
      "State": "Punjab"
  },
  {
      "id": "Khidirpur",
      "label": "Khidirpur",
      "Latitude": 22.542061,
      "Longitude": 88.318954,
      "State": "West Bengal"
  },
  {
      "id": "Khurai",
      "label": "Khurai",
      "Latitude": 24.043468,
      "Longitude": 78.330353,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Khurja",
      "label": "Khurja",
      "Latitude": 28.252222,
      "Longitude": 77.851784,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Kila",
      "label": "Kila",
      "Latitude": 28.23801,
      "Longitude": 77.854912,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Kishangarh",
      "label": "Kishangarh",
      "Latitude": 26.588528,
      "Longitude": 74.872513,
      "State": "Rajasthan"
  },
  {
      "id": "Kochi",
      "label": "Kochi",
      "Latitude": 9.931233,
      "Longitude": 76.267303,
      "State": "Kerala"
  },
  {
      "id": "Kochi",
      "label": "Kochi",
      "Latitude": 9.939093,
      "Longitude": 76.270523,
      "State": "Kerala"
  },
  {
      "id": "Kodad",
      "label": "Kodad",
      "Latitude": 16.99708,
      "Longitude": 79.967361,
      "State": "Telangana"
  },
  {
      "id": "Kolhapur",
      "label": "Kolhapur",
      "Latitude": 16.691307,
      "Longitude": 74.244865,
      "State": "Maharashtra"
  },
  {
      "id": "Kolkata",
      "label": "Kolkata",
      "Latitude": 22.572645,
      "Longitude": 88.363892,
      "State": "West Bengal"
  },
  {
      "id": "Kollam",
      "label": "Kollam",
      "Latitude": 8.893212,
      "Longitude": 76.614143,
      "State": "Kerala"
  },
  {
      "id": "Konavani Palem",
      "label": "Konavani Palem",
      "Latitude": 17.417376,
      "Longitude": 82.741653,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Konnagar",
      "label": "Konnagar",
      "Latitude": 22.700474,
      "Longitude": 88.319069,
      "State": "West Bengal"
  },
  {
      "id": "Kopargaon",
      "label": "Kopargaon",
      "Latitude": 19.883301,
      "Longitude": 74.483299,
      "State": "Maharashtra"
  },
  {
      "id": "Korba",
      "label": "Korba",
      "Latitude": 22.363848,
      "Longitude": 82.73484,
      "State": "Chhattisgarh"
  },
  {
      "id": "Kosumb",
      "label": "Kosumb",
      "Latitude": 17.11458,
      "Longitude": 73.591805,
      "State": "Maharashtra"
  },
  {
      "id": "Kothagudem",
      "label": "Kothagudem",
      "Latitude": 17.554356,
      "Longitude": 80.619736,
      "State": "Telangana"
  },
  {
      "id": "Kothamangalam",
      "label": "Kothamangalam",
      "Latitude": 10.065206,
      "Longitude": 76.629128,
      "State": "Kerala"
  },
  {
      "id": "Kothrud",
      "label": "Kothrud",
      "Latitude": 18.50989,
      "Longitude": 73.807182,
      "State": "Maharashtra"
  },
  {
      "id": "Kotputli",
      "label": "Kotputli",
      "Latitude": 27.703669,
      "Longitude": 76.201195,
      "State": "Rajasthan"
  },
  {
      "id": "Kottayam",
      "label": "Kottayam",
      "Latitude": 9.591441,
      "Longitude": 76.522171,
      "State": "Kerala"
  },
  {
      "id": "Kotulpur",
      "label": "Kotulpur",
      "Latitude": 23.012794,
      "Longitude": 87.593948,
      "State": "West Bengal"
  },
  {
      "id": "Koyambedu",
      "label": "Koyambedu",
      "Latitude": 13.07279,
      "Longitude": 80.176163,
      "State": "Tamil Nadu"
  },
  {
      "id": "Kozhikode",
      "label": "Kozhikode",
      "Latitude": 11.258753,
      "Longitude": 75.780411,
      "State": "Kerala"
  },
  {
      "id": "Krishnagiri",
      "label": "Krishnagiri",
      "Latitude": 12.518611,
      "Longitude": 78.213737,
      "State": "Tamil Nadu"
  },
  {
      "id": "Kuchaman label",
      "label": "Kuchaman label",
      "Latitude": 27.147869,
      "Longitude": 74.859489,
      "State": "Rajasthan"
  },
  {
      "id": "Kumbakonam",
      "label": "Kumbakonam",
      "Latitude": 10.959815,
      "Longitude": 79.380898,
      "State": "Tamil Nadu"
  },
  {
      "id": "Kurnool",
      "label": "Kurnool",
      "Latitude": 15.834536,
      "Longitude": 78.029366,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Kurukshetra",
      "label": "Kurukshetra",
      "Latitude": 29.969513,
      "Longitude": 76.878281,
      "State": "Haryana"
  },
  {
      "id": "Kushtagi",
      "label": "Kushtagi",
      "Latitude": 15.756595,
      "Longitude": 76.192696,
      "State": "Karnataka"
  },
  {
      "id": "Lakhimpur",
      "label": "Lakhimpur",
      "Latitude": 27.947819,
      "Longitude": 80.772141,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Lakhimpur",
      "label": "Lakhimpur",
      "Latitude": 27.94908,
      "Longitude": 80.782402,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Lakhisarai",
      "label": "Lakhisarai",
      "Latitude": 25.168901,
      "Longitude": 86.092987,
      "State": "Bihar"
  },
  {
      "id": "Lalgola",
      "label": "Lalgola",
      "Latitude": 24.417534,
      "Longitude": 88.250343,
      "State": "West Bengal"
  },
  {
      "id": "Lalitpur",
      "label": "Lalitpur",
      "Latitude": 24.68786,
      "Longitude": 78.412018,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Latur",
      "label": "Latur",
      "Latitude": 18.407957,
      "Longitude": 76.576767,
      "State": "Maharashtra"
  },
  {
      "id": "Lonavala",
      "label": "Lonavala",
      "Latitude": 18.74806,
      "Longitude": 73.407219,
      "State": "Maharashtra"
  },
  {
      "id": "Lucknow",
      "label": "Lucknow",
      "Latitude": 26.85,
      "Longitude": 80.949997,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Machilipatnam",
      "label": "Machilipatnam",
      "Latitude": 16.17,
      "Longitude": 81.129997,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Madanapalle",
      "label": "Madanapalle",
      "Latitude": 13.55,
      "Longitude": 78.5,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Madha",
      "label": "Madha",
      "Latitude": 18.033587,
      "Longitude": 75.522079,
      "State": "Maharashtra"
  },
  {
      "id": "Madhopur",
      "label": "Madhopur",
      "Latitude": 32.365288,
      "Longitude": 75.59729,
      "State": "Punjab"
  },
  {
      "id": "Madhubani",
      "label": "Madhubani",
      "Latitude": 26.347883,
      "Longitude": 86.071861,
      "State": "Bihar"
  },
  {
      "id": "Madurai",
      "label": "Madurai",
      "Latitude": 9.939093,
      "Longitude": 78.121719,
      "State": "Tamil Nadu"
  },
  {
      "id": "Mahasamund",
      "label": "Mahasamund",
      "Latitude": 21.109133,
      "Longitude": 82.0979,
      "State": "Chhattisgarh"
  },
  {
      "id": "Mahbubnagar",
      "label": "Mahbubnagar",
      "Latitude": 16.737509,
      "Longitude": 78.008125,
      "State": "Telangana"
  },
  {
      "id": "Maheshtala",
      "label": "Maheshtala",
      "Latitude": 22.511976,
      "Longitude": 88.250992,
      "State": "West Bengal"
  },
  {
      "id": "Mahidpur",
      "label": "Mahidpur",
      "Latitude": 23.486839,
      "Longitude": 75.659157,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Mahoba",
      "label": "Mahoba",
      "Latitude": 25.292509,
      "Longitude": 79.872665,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Mahuva",
      "label": "Mahuva",
      "Latitude": 21.092159,
      "Longitude": 71.770462,
      "State": "Gujarat"
  },
  {
      "id": "Mahuva",
      "label": "Mahuva",
      "Latitude": 21.105001,
      "Longitude": 71.771645,
      "State": "Gujarat"
  },
  {
      "id": "Makrana",
      "label": "Makrana",
      "Latitude": 27.029617,
      "Longitude": 74.716324,
      "State": "Rajasthan"
  },
  {
      "id": "Malad East",
      "label": "Malad East",
      "Latitude": 19.180874,
      "Longitude": 72.857452,
      "State": "Maharashtra"
  },
  {
      "id": "Malappuram",
      "label": "Malappuram",
      "Latitude": 11.072035,
      "Longitude": 76.074005,
      "State": "Kerala"
  },
  {
      "id": "Malda",
      "label": "Malda",
      "Latitude": 25.010841,
      "Longitude": 88.141098,
      "State": "West Bengal"
  },
  {
      "id": "Malegaon",
      "label": "Malegaon",
      "Latitude": 20.560797,
      "Longitude": 74.52507,
      "State": "Maharashtra"
  },
  {
      "id": "Malerkotla",
      "label": "Malerkotla",
      "Latitude": 30.525005,
      "Longitude": 75.890121,
      "State": "Punjab"
  },
  {
      "id": "Mallaguri",
      "label": "Mallaguri",
      "Latitude": 26.743464,
      "Longitude": 88.416252,
      "State": "West Bengal"
  },
  {
      "id": "Malout",
      "label": "Malout",
      "Latitude": 30.191515,
      "Longitude": 74.497864,
      "State": "Punjab"
  },
  {
      "id": "Malvan",
      "label": "Malvan",
      "Latitude": 16.0667,
      "Longitude": 73.466698,
      "State": "Maharashtra"
  },
  {
      "id": "Mandi Gobindgarh",
      "label": "Mandi Gobindgarh",
      "Latitude": 30.682802,
      "Longitude": 76.294212,
      "State": "Punjab"
  },
  {
      "id": "Mandla",
      "label": "Mandla",
      "Latitude": 22.597921,
      "Longitude": 80.371384,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Mandya",
      "label": "Mandya",
      "Latitude": 12.523731,
      "Longitude": 76.894684,
      "State": "Karnataka"
  },
  {
      "id": "Mangaluru",
      "label": "Mangaluru",
      "Latitude": 12.915605,
      "Longitude": 74.855965,
      "State": "Karnataka"
  },
  {
      "id": "Mangrulpir",
      "label": "Mangrulpir",
      "Latitude": 20.316135,
      "Longitude": 77.341171,
      "State": "Maharashtra"
  },
  {
      "id": "Manikchak",
      "label": "Manikchak",
      "Latitude": 25.077787,
      "Longitude": 87.900375,
      "State": "West Bengal"
  },
  {
      "id": "Manikchak",
      "label": "Manikchak",
      "Latitude": 25.077787,
      "Longitude": 87.900375,
      "State": "West Bengal"
  },
  {
      "id": "Manmad",
      "label": "Manmad",
      "Latitude": 20.251549,
      "Longitude": 74.438354,
      "State": "Maharashtra"
  },
  {
      "id": "Mansa",
      "label": "Mansa",
      "Latitude": 23.426788,
      "Longitude": 72.657074,
      "State": "Gujarat"
  },
  {
      "id": "Mansa",
      "label": "Mansa",
      "Latitude": 29.988245,
      "Longitude": 75.379257,
      "State": "Punjab"
  },
  {
      "id": "Mansoorabad",
      "label": "Mansoorabad",
      "Latitude": 17.351372,
      "Longitude": 78.565407,
      "State": "Telangana"
  },
  {
      "id": "Manwath",
      "label": "Manwath",
      "Latitude": 19.299999,
      "Longitude": 76.5,
      "State": "Maharashtra"
  },
  {
      "id": "Markapur",
      "label": "Markapur",
      "Latitude": 15.764501,
      "Longitude": 79.259491,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Masaurhi",
      "label": "Masaurhi",
      "Latitude": 25.35128,
      "Longitude": 85.031143,
      "State": "Bihar"
  },
  {
      "id": "Mathura",
      "label": "Mathura",
      "Latitude": 27.492413,
      "Longitude": 77.673676,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Mau",
      "label": "Mau",
      "Latitude": 25.949638,
      "Longitude": 83.558647,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Mavdi",
      "label": "Mavdi",
      "Latitude": 22.259392,
      "Longitude": 70.777184,
      "State": "Gujarat"
  },
  {
      "id": "Medinipur",
      "label": "Medinipur",
      "Latitude": 22.430889,
      "Longitude": 87.321487,
      "State": "West Bengal"
  },
  {
      "id": "Meerut",
      "label": "Meerut",
      "Latitude": 28.984644,
      "Longitude": 77.705956,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Mehkar",
      "label": "Mehkar",
      "Latitude": 20.149822,
      "Longitude": 76.574036,
      "State": "Maharashtra"
  },
  {
      "id": "Mehsana",
      "label": "Mehsana",
      "Latitude": 23.586761,
      "Longitude": 72.369949,
      "State": "Gujarat"
  },
  {
      "id": "Melur",
      "label": "Melur",
      "Latitude": 10.030623,
      "Longitude": 78.34021,
      "State": "Tamil Nadu"
  },
  {
      "id": "Mettupalayam",
      "label": "Mettupalayam",
      "Latitude": 11.289087,
      "Longitude": 76.940971,
      "State": "Tamil Nadu"
  },
  {
      "id": "Mettur",
      "label": "Mettur",
      "Latitude": 11.786253,
      "Longitude": 77.800781,
      "State": "Tamil Nadu"
  },
  {
      "id": "Mhow",
      "label": "Mhow",
      "Latitude": 22.552437,
      "Longitude": 75.756531,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Mira Bhayandar",
      "label": "Mira Bhayandar",
      "Latitude": 19.295233,
      "Longitude": 72.854393,
      "State": "Maharashtra"
  },
  {
      "id": "Mirzapur",
      "label": "Mirzapur",
      "Latitude": 25.133699,
      "Longitude": 82.56443,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Modinagar",
      "label": "Modinagar",
      "Latitude": 28.838299,
      "Longitude": 77.581055,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Moga",
      "label": "Moga",
      "Latitude": 30.81646,
      "Longitude": 75.171707,
      "State": "Punjab"
  },
  {
      "id": "Moradabad",
      "label": "Moradabad",
      "Latitude": 28.841064,
      "Longitude": 78.795319,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Morbi",
      "label": "Morbi",
      "Latitude": 22.811989,
      "Longitude": 70.823616,
      "State": "Gujarat"
  },
  {
      "id": "Morena",
      "label": "Morena",
      "Latitude": 26.5,
      "Longitude": 78,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Morshi",
      "label": "Morshi",
      "Latitude": 21.324196,
      "Longitude": 78.013832,
      "State": "Maharashtra"
  },
  {
      "id": "Motihari",
      "label": "Motihari",
      "Latitude": 26.65,
      "Longitude": 84.916664,
      "State": "Bihar"
  },
  {
      "id": "Mudhol",
      "label": "Mudhol",
      "Latitude": 16.333309,
      "Longitude": 75.28582,
      "State": "Karnataka"
  },
  {
      "id": "Mumbai",
      "label": "Mumbai",
      "Latitude": 19.07609,
      "Longitude": 72.877426,
      "State": "Maharashtra"
  },
  {
      "id": "Munger",
      "label": "Munger",
      "Latitude": 25.37571,
      "Longitude": 86.474373,
      "State": "Bihar"
  },
  {
      "id": "Muradnagar",
      "label": "Muradnagar",
      "Latitude": 28.771646,
      "Longitude": 77.507561,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Murshidabad",
      "label": "Murshidabad",
      "Latitude": 24.175903,
      "Longitude": 88.280182,
      "State": "West Bengal"
  },
  {
      "id": "Muzaffarnagar",
      "label": "Muzaffarnagar",
      "Latitude": 29.471397,
      "Longitude": 77.696732,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Muzaffarpur",
      "label": "Muzaffarpur",
      "Latitude": 26.121473,
      "Longitude": 85.368752,
      "State": "Bihar"
  },
  {
      "id": "Mysore division",
      "label": "Mysore division",
      "Latitude": 12.311827,
      "Longitude": 76.652985,
      "State": "Karnataka"
  },
  {
      "id": "Mysuru",
      "label": "Mysuru",
      "Latitude": 12.29581,
      "Longitude": 76.639381,
      "State": "Karnataka"
  },
  {
      "id": "Nabadwip",
      "label": "Nabadwip",
      "Latitude": 23.406979,
      "Longitude": 88.365593,
      "State": "West Bengal"
  },
  {
      "id": "Nabha",
      "label": "Nabha",
      "Latitude": 30.373674,
      "Longitude": 76.145187,
      "State": "Punjab"
  },
  {
      "id": "Nadiad",
      "label": "Nadiad",
      "Latitude": 22.700001,
      "Longitude": 72.870003,
      "State": "Gujarat"
  },
  {
      "id": "Nagaur",
      "label": "Nagaur",
      "Latitude": 27.207006,
      "Longitude": 73.742294,
      "State": "Rajasthan"
  },
  {
      "id": "Nagercoil",
      "label": "Nagercoil",
      "Latitude": 8.17445,
      "Longitude": 77.432159,
      "State": "Tamil Nadu"
  },
  {
      "id": "Nagpur",
      "label": "Nagpur",
      "Latitude": 21.146633,
      "Longitude": 79.08886,
      "State": "Maharashtra"
  },
  {
      "id": "Naini",
      "label": "Naini",
      "Latitude": 25.393978,
      "Longitude": 81.85405,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Najibabad",
      "label": "Najibabad",
      "Latitude": 29.607981,
      "Longitude": 78.342674,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Nalasopara",
      "label": "Nalasopara",
      "Latitude": 19.432278,
      "Longitude": 72.7743,
      "State": "Maharashtra"
  },
  {
      "id": "Nalgonda",
      "label": "Nalgonda",
      "Latitude": 17.05662,
      "Longitude": 79.268333,
      "State": "Telangana"
  },
  {
      "id": "Namakkal",
      "label": "Namakkal",
      "Latitude": 11.229592,
      "Longitude": 78.171158,
      "State": "Tamil Nadu"
  },
  {
      "id": "Nanded",
      "label": "Nanded",
      "Latitude": 19.169815,
      "Longitude": 77.319717,
      "State": "Maharashtra"
  },
  {
      "id": "Nandyal",
      "label": "Nandyal",
      "Latitude": 15.478569,
      "Longitude": 78.483093,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Nanjangud",
      "label": "Nanjangud",
      "Latitude": 12.12,
      "Longitude": 76.68,
      "State": "Karnataka"
  },
  {
      "id": "Narnaul",
      "label": "Narnaul",
      "Latitude": 28.065796,
      "Longitude": 76.101479,
      "State": "Haryana"
  },
  {
      "id": "Narsampet",
      "label": "Narsampet",
      "Latitude": 17.928122,
      "Longitude": 79.894531,
      "State": "Telangana"
  },
  {
      "id": "Narsapur",
      "label": "Narsapur",
      "Latitude": 16.432983,
      "Longitude": 81.696617,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Narwana",
      "label": "Narwana",
      "Latitude": 29.592957,
      "Longitude": 76.119247,
      "State": "Haryana"
  },
  {
      "id": "Nashik",
      "label": "Nashik",
      "Latitude": 19.997454,
      "Longitude": 73.789803,
      "State": "Maharashtra"
  },
  {
      "id": "Nawada",
      "label": "Nawada",
      "Latitude": 24.879999,
      "Longitude": 85.529999,
      "State": "Bihar"
  },
  {
      "id": "Nawapara Nagar",
      "label": "Nawapara Nagar",
      "Latitude": 20.973513,
      "Longitude": 81.857948,
      "State": "Chhattisgarh"
  },
  {
      "id": "Naya Raipur",
      "label": "Naya Raipur",
      "Latitude": 21.164993,
      "Longitude": 81.775307,
      "State": "Chhattisgarh"
  },
  {
      "id": "Nayagarh",
      "label": "Nayagarh",
      "Latitude": 20.127028,
      "Longitude": 85.105057,
      "State": "Odisha"
  },
  {
      "id": "Nedumangad",
      "label": "Nedumangad",
      "Latitude": 8.603333,
      "Longitude": 77.002777,
      "State": "Kerala"
  },
  {
      "id": "Nellore",
      "label": "Nellore",
      "Latitude": 14.442599,
      "Longitude": 79.986458,
      "State": "Andhra Pradesh"
  },
  {
      "id": "New Delhi",
      "label": "New Delhi",
      "Latitude": 28.6448,
      "Longitude": 77.216721,
      "State": "Delhi"
  },
  {
      "id": "Newasa",
      "label": "Newasa",
      "Latitude": 19.551146,
      "Longitude": 74.928162,
      "State": "Maharashtra"
  },
  {
      "id": "Nilanga",
      "label": "Nilanga",
      "Latitude": 18.125875,
      "Longitude": 76.750969,
      "State": "Maharashtra"
  },
  {
      "id": "Nimbahera",
      "label": "Nimbahera",
      "Latitude": 24.620001,
      "Longitude": 74.68,
      "State": "Rajasthan"
  },
  {
      "id": "Nipani",
      "label": "Nipani",
      "Latitude": 16.4,
      "Longitude": 74.383301,
      "State": "Karnataka"
  },
  {
      "id": "Nohar",
      "label": "Nohar",
      "Latitude": 29.185776,
      "Longitude": 74.771782,
      "State": "Rajasthan"
  },
  {
      "id": "Noida",
      "label": "Noida",
      "Latitude": 28.535517,
      "Longitude": 77.391029,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Noida",
      "label": "Noida",
      "Latitude": 28.535517,
      "Longitude": 77.391029,
      "State": "Uttar Pradesh"
  },
  {
      "id": "North Lakhimpur",
      "label": "North Lakhimpur",
      "Latitude": 27.236317,
      "Longitude": 94.09584,
      "State": "Assam"
  },
  {
      "id": "North Paravoor",
      "label": "North Paravoor",
      "Latitude": 10.140487,
      "Longitude": 76.23053,
      "State": "Kerala"
  },
  {
      "id": "Ongole",
      "label": "Ongole",
      "Latitude": 15.505723,
      "Longitude": 80.049919,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Ooty",
      "label": "Ooty",
      "Latitude": 11.41,
      "Longitude": 76.699997,
      "State": "Tamil Nadu"
  },
  {
      "id": "Orai",
      "label": "Orai",
      "Latitude": 25.98,
      "Longitude": 79.470001,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Orai",
      "label": "Orai",
      "Latitude": 25.989836,
      "Longitude": 79.450035,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Osmanabad",
      "label": "Osmanabad",
      "Latitude": 18.186066,
      "Longitude": 76.041939,
      "State": "Maharashtra"
  },
  {
      "id": "Padrauna",
      "label": "Padrauna",
      "Latitude": 26.898392,
      "Longitude": 83.979713,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Pakur",
      "label": "Pakur",
      "Latitude": 24.633568,
      "Longitude": 87.849251,
      "State": "Jharkhand"
  },
  {
      "id": "Palakkad",
      "label": "Palakkad",
      "Latitude": 10.784703,
      "Longitude": 76.653145,
      "State": "Kerala"
  },
  {
      "id": "Palampur",
      "label": "Palampur",
      "Latitude": 32.110542,
      "Longitude": 76.536224,
      "State": "Himachal Pradesh"
  },
  {
      "id": "Palanpur",
      "label": "Palanpur",
      "Latitude": 24.179331,
      "Longitude": 72.426682,
      "State": "Gujarat"
  },
  {
      "id": "Pali",
      "label": "Pali",
      "Latitude": 25.771315,
      "Longitude": 73.323685,
      "State": "Rajasthan"
  },
  {
      "id": "Paltan Bazaar",
      "label": "Paltan Bazaar",
      "Latitude": 26.182245,
      "Longitude": 91.754723,
      "State": "Assam"
  },
  {
      "id": "Palwal",
      "label": "Palwal",
      "Latitude": 28.148735,
      "Longitude": 77.332024,
      "State": "Haryana"
  },
  {
      "id": "Palwan",
      "label": "Palwan",
      "Latitude": 18.970057,
      "Longitude": 75.72065,
      "State": "Maharashtra"
  },
  {
      "id": "Panaji",
      "label": "Panaji",
      "Latitude": 15.496777,
      "Longitude": 73.827827,
      "State": "Goa"
  },
  {
      "id": "Panchkula",
      "label": "Panchkula",
      "Latitude": 30.695202,
      "Longitude": 76.854172,
      "State": "Haryana"
  },
  {
      "id": "Pandharpur",
      "label": "Pandharpur",
      "Latitude": 17.674553,
      "Longitude": 75.323723,
      "State": "Maharashtra"
  },
  {
      "id": "Panipat",
      "label": "Panipat",
      "Latitude": 29.398928,
      "Longitude": 76.977081,
      "State": "Haryana"
  },
  {
      "id": "Panskura",
      "label": "Panskura",
      "Latitude": 22.395582,
      "Longitude": 87.741882,
      "State": "West Bengal"
  },
  {
      "id": "Paramakudi",
      "label": "Paramakudi",
      "Latitude": 9.548395,
      "Longitude": 78.591637,
      "State": "Tamil Nadu"
  },
  {
      "id": "Paratwada",
      "label": "Paratwada",
      "Latitude": 21.27306,
      "Longitude": 77.523422,
      "State": "Maharashtra"
  },
  {
      "id": "Parbhani",
      "label": "Parbhani",
      "Latitude": 19.25779,
      "Longitude": 76.773743,
      "State": "Maharashtra"
  },
  {
      "id": "Parli Vaijnath",
      "label": "Parli Vaijnath",
      "Latitude": 18.871204,
      "Longitude": 76.535568,
      "State": "Maharashtra"
  },
  {
      "id": "Partur",
      "label": "Partur",
      "Latitude": 19.595484,
      "Longitude": 76.211067,
      "State": "Maharashtra"
  },
  {
      "id": "Patan",
      "label": "Patan",
      "Latitude": 23.849325,
      "Longitude": 72.126625,
      "State": "Gujarat"
  },
  {
      "id": "Pathankot",
      "label": "Pathankot",
      "Latitude": 32.265942,
      "Longitude": 75.646873,
      "State": "Punjab"
  },
  {
      "id": "Pathardi Phata",
      "label": "Pathardi Phata",
      "Latitude": 19.946922,
      "Longitude": 73.765434,
      "State": "Maharashtra"
  },
  {
      "id": "Patiala",
      "label": "Patiala",
      "Latitude": 30.34,
      "Longitude": 76.379997,
      "State": "Punjab"
  },
  {
      "id": "Patna",
      "label": "Patna",
      "Latitude": 25.612677,
      "Longitude": 85.158875,
      "State": "Bihar"
  },
  {
      "id": "Payradanga",
      "label": "Payradanga",
      "Latitude": 23.125587,
      "Longitude": 88.546867,
      "State": "West Bengal"
  },
  {
      "id": "Phagwara",
      "label": "Phagwara",
      "Latitude": 31.22402,
      "Longitude": 75.770798,
      "State": "Punjab"
  },
  {
      "id": "Pilibhit",
      "label": "Pilibhit",
      "Latitude": 28.627926,
      "Longitude": 79.804176,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Pilkhuwa",
      "label": "Pilkhuwa",
      "Latitude": 28.711969,
      "Longitude": 77.654457,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Pindwara",
      "label": "Pindwara",
      "Latitude": 24.7945,
      "Longitude": 73.055,
      "State": "Rajasthan"
  },
  {
      "id": "Pipariya",
      "label": "Pipariya",
      "Latitude": 22.762886,
      "Longitude": 78.352478,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Pithampur",
      "label": "Pithampur",
      "Latitude": 22.610683,
      "Longitude": 75.680862,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Pithapuram",
      "label": "Pithapuram",
      "Latitude": 17.112427,
      "Longitude": 82.252899,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Pithoragarh",
      "label": "Pithoragarh",
      "Latitude": 29.582861,
      "Longitude": 80.218185,
      "State": "Uttarakhand"
  },
  {
      "id": "Pollachi",
      "label": "Pollachi",
      "Latitude": 10.657274,
      "Longitude": 77.010666,
      "State": "Tamil Nadu"
  },
  {
      "id": "Porbandar",
      "label": "Porbandar",
      "Latitude": 21.640575,
      "Longitude": 69.605965,
      "State": "Gujarat"
  },
  {
      "id": "Port Blair",
      "label": "Port Blair",
      "Latitude": 11.623377,
      "Longitude": 92.726486,
      "State": "Andaman and Nicobar Islands"
  },
  {
      "id": "Prayagraj",
      "label": "Prayagraj",
      "Latitude": 25.473034,
      "Longitude": 81.878357,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Proddatur",
      "label": "Proddatur",
      "Latitude": 14.752805,
      "Longitude": 78.552757,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Puducherry",
      "label": "Puducherry",
      "Latitude": 11.916064,
      "Longitude": 79.812325,
      "State": "Tamil Nadu"
  },
  {
      "id": "Pudukkottai",
      "label": "Pudukkottai",
      "Latitude": 10.379663,
      "Longitude": 78.820847,
      "State": "Tamil Nadu"
  },
  {
      "id": "Pulivendula",
      "label": "Pulivendula",
      "Latitude": 14.422232,
      "Longitude": 78.226341,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Pune",
      "label": "Pune",
      "Latitude": 18.516726,
      "Longitude": 73.856255,
      "State": "Maharashtra"
  },
  {
      "id": "Puri",
      "label": "Puri",
      "Latitude": 19.817743,
      "Longitude": 85.828629,
      "State": "Odisha"
  },
  {
      "id": "Purnea",
      "label": "Purnea",
      "Latitude": 25.771103,
      "Longitude": 87.482185,
      "State": "Bihar"
  },
  {
      "id": "Purulia",
      "label": "Purulia",
      "Latitude": 23.342257,
      "Longitude": 86.362839,
      "State": "West Bengal"
  },
  {
      "id": "Pusad",
      "label": "Pusad",
      "Latitude": 19.912676,
      "Longitude": 77.56691,
      "State": "Maharashtra"
  },
  {
      "id": "Puthoor",
      "label": "Puthoor",
      "Latitude": 9.04,
      "Longitude": 76.709999,
      "State": "Kerala"
  },
  {
      "id": "Puttur",
      "label": "Puttur",
      "Latitude": 12.768676,
      "Longitude": 75.207062,
      "State": "Karnataka"
  },
  {
      "id": "RAK Tiles",
      "label": "RAK Tiles",
      "Latitude": 31.604889,
      "Longitude": 76.919533,
      "State": "Himachal Pradesh"
  },
  {
      "id": "Raebareli",
      "label": "Raebareli",
      "Latitude": 26.230299,
      "Longitude": 81.240891,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Rahon",
      "label": "Rahon",
      "Latitude": 31.052128,
      "Longitude": 76.1175,
      "State": "Punjab"
  },
  {
      "id": "Raichur",
      "label": "Raichur",
      "Latitude": 16.200829,
      "Longitude": 77.362289,
      "State": "Karnataka"
  },
  {
      "id": "Raiganj",
      "label": "Raiganj",
      "Latitude": 25.61853,
      "Longitude": 88.125587,
      "State": "West Bengal"
  },
  {
      "id": "Raigarh",
      "label": "Raigarh",
      "Latitude": 21.9,
      "Longitude": 83.400002,
      "State": "Chhattisgarh"
  },
  {
      "id": "Raipur",
      "label": "Raipur",
      "Latitude": 21.25,
      "Longitude": 81.629997,
      "State": "Chhattisgarh"
  },
  {
      "id": "Rajahmundry",
      "label": "Rajahmundry",
      "Latitude": 17.004393,
      "Longitude": 81.783325,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Rajendra Nagar",
      "label": "Rajendra Nagar",
      "Latitude": 20.450474,
      "Longitude": 85.905533,
      "State": "Odisha"
  },
  {
      "id": "Rajgangpur",
      "label": "Rajgangpur",
      "Latitude": 22.205206,
      "Longitude": 84.584251,
      "State": "Odisha"
  },
  {
      "id": "Rajgir",
      "label": "Rajgir",
      "Latitude": 25.017258,
      "Longitude": 85.416161,
      "State": "Bihar"
  },
  {
      "id": "Rajkot",
      "label": "Rajkot",
      "Latitude": 22.308155,
      "Longitude": 70.800705,
      "State": "Gujarat"
  },
  {
      "id": "Rajnandgaon",
      "label": "Rajnandgaon",
      "Latitude": 21.097855,
      "Longitude": 81.033707,
      "State": "Chhattisgarh"
  },
  {
      "id": "Rajpura",
      "label": "Rajpura",
      "Latitude": 30.483997,
      "Longitude": 76.593948,
      "State": "Punjab"
  },
  {
      "id": "Rajsamand",
      "label": "Rajsamand",
      "Latitude": 25.0667,
      "Longitude": 73.883301,
      "State": "Rajasthan"
  },
  {
      "id": "Ramagundam",
      "label": "Ramagundam",
      "Latitude": 18.76182,
      "Longitude": 79.480904,
      "State": "Telangana"
  },
  {
      "id": "Ramanagara",
      "label": "Ramanagara",
      "Latitude": 12.715035,
      "Longitude": 77.281296,
      "State": "Karnataka"
  },
  {
      "id": "Rampur",
      "label": "Rampur",
      "Latitude": 28.802958,
      "Longitude": 79.025444,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Ranaghat",
      "label": "Ranaghat",
      "Latitude": 23.174049,
      "Longitude": 88.563934,
      "State": "West Bengal"
  },
  {
      "id": "Ranchi",
      "label": "Ranchi",
      "Latitude": 23.344315,
      "Longitude": 85.296013,
      "State": "Jharkhand"
  },
  {
      "id": "Ranebennur",
      "label": "Ranebennur",
      "Latitude": 14.623801,
      "Longitude": 75.621788,
      "State": "Karnataka"
  },
  {
      "id": "Rangia",
      "label": "Rangia",
      "Latitude": 26.437252,
      "Longitude": 91.62011,
      "State": "Assam"
  },
  {
      "id": "Rasayani",
      "label": "Rasayani",
      "Latitude": 18.901457,
      "Longitude": 73.176132,
      "State": "Maharashtra"
  },
  {
      "id": "Ratlam",
      "label": "Ratlam",
      "Latitude": 23.334169,
      "Longitude": 75.037636,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Ratnagiri",
      "label": "Ratnagiri",
      "Latitude": 16.994444,
      "Longitude": 73.300003,
      "State": "Maharashtra"
  },
  {
      "id": "Renukoot",
      "label": "Renukoot",
      "Latitude": 24.220198,
      "Longitude": 83.035957,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Rewa",
      "label": "Rewa",
      "Latitude": 24.530727,
      "Longitude": 81.29911,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Rishikesh",
      "label": "Rishikesh",
      "Latitude": 30.08716,
      "Longitude": 78.268112,
      "State": "Uttarakhand"
  },
  {
      "id": "Robertsganj",
      "label": "Robertsganj",
      "Latitude": 24.685001,
      "Longitude": 83.068352,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Rohtak",
      "label": "Rohtak",
      "Latitude": 28.895515,
      "Longitude": 76.606613,
      "State": "Haryana"
  },
  {
      "id": "Roorkee",
      "label": "Roorkee",
      "Latitude": 29.854263,
      "Longitude": 77.888,
      "State": "Uttarakhand"
  },
  {
      "id": "Rudrapur",
      "label": "Rudrapur",
      "Latitude": 28.978298,
      "Longitude": 79.399612,
      "State": "Uttarakhand"
  },
  {
      "id": "Rupnagar",
      "label": "Rupnagar",
      "Latitude": 30.975254,
      "Longitude": 76.527328,
      "State": "Punjab"
  },
  {
      "id": "Sagar",
      "label": "Sagar",
      "Latitude": 14.16704,
      "Longitude": 75.040298,
      "State": "Karnataka"
  },
  {
      "id": "Sagar",
      "label": "Sagar",
      "Latitude": 23.83403,
      "Longitude": 78.746567,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Saharanpur",
      "label": "Saharanpur",
      "Latitude": 29.959694,
      "Longitude": 77.549057,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Saharsa",
      "label": "Saharsa",
      "Latitude": 25.883495,
      "Longitude": 86.600624,
      "State": "Bihar"
  },
  {
      "id": "Sahibzada Ajit Singh Nagar",
      "label": "Sahibzada Ajit Singh Nagar",
      "Latitude": 30.704649,
      "Longitude": 76.717873,
      "State": "Punjab"
  },
  {
      "id": "Saidabad",
      "label": "Saidabad",
      "Latitude": 28.526592,
      "Longitude": 77.290169,
      "State": "Delhi"
  },
  {
      "id": "Saideep Enterprises",
      "label": "Saideep Enterprises",
      "Latitude": 19.969227,
      "Longitude": 73.743195,
      "State": "Maharashtra"
  },
  {
      "id": "Saint Dnyaneshwar Garden and Paithan park",
      "label": "Saint Dnyaneshwar Garden and Paithan park",
      "Latitude": 19.487707,
      "Longitude": 75.380768,
      "State": "Maharashtra"
  },
  {
      "id": "Salem",
      "label": "Salem",
      "Latitude": 11.664325,
      "Longitude": 78.146011,
      "State": "Tamil Nadu"
  },
  {
      "id": "Salipur",
      "label": "Salipur",
      "Latitude": 20.484348,
      "Longitude": 86.119194,
      "State": "Odisha"
  },
  {
      "id": "Samastipur",
      "label": "Samastipur",
      "Latitude": 25.862968,
      "Longitude": 85.781029,
      "State": "Bihar"
  },
  {
      "id": "Sambalpur",
      "label": "Sambalpur",
      "Latitude": 21.468185,
      "Longitude": 83.975403,
      "State": "Odisha"
  },
  {
      "id": "Sambhal",
      "label": "Sambhal",
      "Latitude": 28.590361,
      "Longitude": 78.571762,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Sangamner",
      "label": "Sangamner",
      "Latitude": 19.581099,
      "Longitude": 74.205009,
      "State": "Maharashtra"
  },
  {
      "id": "Sangareddy",
      "label": "Sangareddy",
      "Latitude": 17.611629,
      "Longitude": 78.08181,
      "State": "Telangana"
  },
  {
      "id": "Sangli",
      "label": "Sangli",
      "Latitude": 16.867634,
      "Longitude": 74.570389,
      "State": "Maharashtra"
  },
  {
      "id": "Sankari",
      "label": "Sankari",
      "Latitude": 11.477696,
      "Longitude": 77.873886,
      "State": "Tamil Nadu"
  },
  {
      "id": "Santha",
      "label": "Santha",
      "Latitude": 26.994154,
      "Longitude": 83.034798,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Santipur",
      "label": "Santipur",
      "Latitude": 23.255541,
      "Longitude": 88.437363,
      "State": "West Bengal"
  },
  {
      "id": "Sardarshahar",
      "label": "Sardarshahar",
      "Latitude": 28.440554,
      "Longitude": 74.493011,
      "State": "Rajasthan"
  },
  {
      "id": "Sasaram",
      "label": "Sasaram",
      "Latitude": 24.953514,
      "Longitude": 84.011787,
      "State": "Bihar"
  },
  {
      "id": "Saswad",
      "label": "Saswad",
      "Latitude": 18.344749,
      "Longitude": 74.031715,
      "State": "Maharashtra"
  },
  {
      "id": "Satara",
      "label": "Satara",
      "Latitude": 17.691401,
      "Longitude": 74.000938,
      "State": "Maharashtra"
  },
  {
      "id": "Sathankulam",
      "label": "Sathankulam",
      "Latitude": 8.444186,
      "Longitude": 77.912804,
      "State": "Tamil Nadu"
  },
  {
      "id": "Sathy",
      "label": "Sathy",
      "Latitude": 11.504776,
      "Longitude": 77.238396,
      "State": "Tamil Nadu"
  },
  {
      "id": "Satna",
      "label": "Satna",
      "Latitude": 24.579716,
      "Longitude": 80.832176,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Savner",
      "label": "Savner",
      "Latitude": 21.385311,
      "Longitude": 78.92186,
      "State": "Maharashtra"
  },
  {
      "id": "Sawaimadhopur",
      "label": "Sawaimadhopur",
      "Latitude": 25.983334,
      "Longitude": 76.366669,
      "State": "Rajasthan"
  },
  {
      "id": "Secunderabad",
      "label": "Secunderabad",
      "Latitude": 17.43993,
      "Longitude": 78.498276,
      "State": "Telangana"
  },
  {
      "id": "Secunderabad",
      "label": "Secunderabad",
      "Latitude": 17.440325,
      "Longitude": 78.498894,
      "State": "Telangana"
  },
  {
      "id": "Sedam",
      "label": "Sedam",
      "Latitude": 17.179991,
      "Longitude": 77.275368,
      "State": "Karnataka"
  },
  {
      "id": "Sehore",
      "label": "Sehore",
      "Latitude": 23.198437,
      "Longitude": 77.095184,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Sendhwa",
      "label": "Sendhwa",
      "Latitude": 21.681898,
      "Longitude": 75.094269,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Seoni",
      "label": "Seoni",
      "Latitude": 22.086868,
      "Longitude": 79.543488,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Shahada",
      "label": "Shahada",
      "Latitude": 21.546185,
      "Longitude": 74.470009,
      "State": "Maharashtra"
  },
  {
      "id": "Shahdol",
      "label": "Shahdol",
      "Latitude": 23.302189,
      "Longitude": 81.356804,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Shahjahanpur",
      "label": "Shahjahanpur",
      "Latitude": 27.883743,
      "Longitude": 79.912247,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Shajapur",
      "label": "Shajapur",
      "Latitude": 23.4333,
      "Longitude": 76.266701,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Shamli",
      "label": "Shamli",
      "Latitude": 29.448055,
      "Longitude": 77.31028,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Shamshabad",
      "label": "Shamshabad",
      "Latitude": 17.25116,
      "Longitude": 78.437737,
      "State": "Telangana"
  },
  {
      "id": "Shegaon",
      "label": "Shegaon",
      "Latitude": 20.792713,
      "Longitude": 76.694328,
      "State": "Maharashtra"
  },
  {
      "id": "Sheopur",
      "label": "Sheopur",
      "Latitude": 25.67,
      "Longitude": 76.699997,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Shikohabad",
      "label": "Shikohabad",
      "Latitude": 27.108416,
      "Longitude": 78.584602,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Shimla",
      "label": "Shimla",
      "Latitude": 31.104605,
      "Longitude": 77.173424,
      "State": "Himachal Pradesh"
  },
  {
      "id": "Shimoga",
      "label": "Shimoga",
      "Latitude": 13.92993,
      "Longitude": 75.5681,
      "State": "Karnataka"
  },
  {
      "id": "Shivpuri",
      "label": "Shivpuri",
      "Latitude": 25.42412,
      "Longitude": 77.65799,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Shrirampur",
      "label": "Shrirampur",
      "Latitude": 19.620296,
      "Longitude": 74.654655,
      "State": "Maharashtra"
  },
  {
      "id": "Siddipet",
      "label": "Siddipet",
      "Latitude": 18.101904,
      "Longitude": 78.852074,
      "State": "Telangana"
  },
  {
      "id": "Sikandra",
      "label": "Sikandra",
      "Latitude": 26.367811,
      "Longitude": 79.629158,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Sikandrabad",
      "label": "Sikandrabad",
      "Latitude": 28.452393,
      "Longitude": 77.697205,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Sikar",
      "label": "Sikar",
      "Latitude": 27.615406,
      "Longitude": 75.125885,
      "State": "Rajasthan"
  },
  {
      "id": "Silchar",
      "label": "Silchar",
      "Latitude": 24.833271,
      "Longitude": 92.778908,
      "State": "Assam"
  },
  {
      "id": "Silchar",
      "label": "Silchar",
      "Latitude": 24.833946,
      "Longitude": 92.779282,
      "State": "Assam"
  },
  {
      "id": "Siliguri",
      "label": "Siliguri",
      "Latitude": 26.732311,
      "Longitude": 88.410286,
      "State": "West Bengal"
  },
  {
      "id": "Simlapal",
      "label": "Simlapal",
      "Latitude": 22.916706,
      "Longitude": 87.070351,
      "State": "West Bengal"
  },
  {
      "id": "Sinnar",
      "label": "Sinnar",
      "Latitude": 19.85306,
      "Longitude": 74.000633,
      "State": "Maharashtra"
  },
  {
      "id": "Sircilla",
      "label": "Sircilla",
      "Latitude": 18.38662,
      "Longitude": 78.802246,
      "State": "Telangana"
  },
  {
      "id": "Sirhind",
      "label": "Sirhind",
      "Latitude": 30.64382,
      "Longitude": 76.394119,
      "State": "Punjab"
  },
  {
      "id": "Sirohi",
      "label": "Sirohi",
      "Latitude": 24.882618,
      "Longitude": 72.858894,
      "State": "Rajasthan"
  },
  {
      "id": "Sirsa",
      "label": "Sirsa",
      "Latitude": 29.536535,
      "Longitude": 75.025505,
      "State": "Haryana"
  },
  {
      "id": "Sitalkuchi",
      "label": "Sitalkuchi",
      "Latitude": 26.169069,
      "Longitude": 89.180122,
      "State": "West Bengal"
  },
  {
      "id": "Sitamarhi",
      "label": "Sitamarhi",
      "Latitude": 26.587299,
      "Longitude": 85.501183,
      "State": "Bihar"
  },
  {
      "id": "Sitapur",
      "label": "Sitapur",
      "Latitude": 27.57509,
      "Longitude": 80.663765,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Sitarganj",
      "label": "Sitarganj",
      "Latitude": 28.923548,
      "Longitude": 79.700722,
      "State": "Uttarakhand"
  },
  {
      "id": "Sivakasi",
      "label": "Sivakasi",
      "Latitude": 9.453126,
      "Longitude": 77.807236,
      "State": "Tamil Nadu"
  },
  {
      "id": "Sivasagar",
      "label": "Sivasagar",
      "Latitude": 26.98,
      "Longitude": 94.629997,
      "State": "Assam"
  },
  {
      "id": "Siwan",
      "label": "Siwan",
      "Latitude": 26.219622,
      "Longitude": 84.356659,
      "State": "Bihar"
  },
  {
      "id": "Sojat",
      "label": "Sojat",
      "Latitude": 25.923853,
      "Longitude": 73.665131,
      "State": "Rajasthan"
  },
  {
      "id": "Solapur",
      "label": "Solapur",
      "Latitude": 17.65992,
      "Longitude": 75.906387,
      "State": "Maharashtra"
  },
  {
      "id": "Sonepat",
      "label": "Sonepat",
      "Latitude": 28.928574,
      "Longitude": 77.091492,
      "State": "Haryana"
  },
  {
      "id": "South Dum Dum",
      "label": "South Dum Dum",
      "Latitude": 22.607672,
      "Longitude": 88.394493,
      "State": "West Bengal"
  },
  {
      "id": "Sri Ganganagar",
      "label": "Sri Ganganagar",
      "Latitude": 29.903839,
      "Longitude": 73.87719,
      "State": "Rajasthan"
  },
  {
      "id": "Sri Muktsar Sahib",
      "label": "Sri Muktsar Sahib",
      "Latitude": 30.480042,
      "Longitude": 74.518204,
      "State": "Punjab"
  },
  {
      "id": "Srikakulam",
      "label": "Srikakulam",
      "Latitude": 18.296974,
      "Longitude": 83.896782,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Srikalahasti",
      "label": "Srikalahasti",
      "Latitude": 13.75269,
      "Longitude": 79.703758,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Srinagar",
      "label": "Srinagar",
      "Latitude": 30.221399,
      "Longitude": 78.780045,
      "State": "Uttarakhand"
  },
  {
      "id": "Srinagar",
      "label": "Srinagar",
      "Latitude": 34.083656,
      "Longitude": 74.797371,
      "State": "Jammu and Kashmir"
  },
  {
      "id": "Sriperumbudur",
      "label": "Sriperumbudur",
      "Latitude": 12.97378,
      "Longitude": 79.94133,
      "State": "Tamil Nadu"
  },
  {
      "id": "Srivilliputhur",
      "label": "Srivilliputhur",
      "Latitude": 9.512137,
      "Longitude": 77.634087,
      "State": "Tamil Nadu"
  },
  {
      "id": "Success Point",
      "label": "Success Point",
      "Latitude": 20.112093,
      "Longitude": 79.118698,
      "State": "Maharashtra"
  },
  {
      "id": "Sujangarh",
      "label": "Sujangarh",
      "Latitude": 27.696903,
      "Longitude": 74.452972,
      "State": "Rajasthan"
  },
  {
      "id": "Sukdal",
      "label": "Sukdal",
      "Latitude": 23.356615,
      "Longitude": 87.656837,
      "State": "West Bengal"
  },
  {
      "id": "Sultanpur",
      "label": "Sultanpur",
      "Latitude": 26.264776,
      "Longitude": 82.072708,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Sunam",
      "label": "Sunam",
      "Latitude": 30.129999,
      "Longitude": 75.800003,
      "State": "Punjab"
  },
  {
      "id": "Surajpur",
      "label": "Surajpur",
      "Latitude": 23.223047,
      "Longitude": 82.87056,
      "State": "Chhattisgarh"
  },
  {
      "id": "Surat",
      "label": "Surat",
      "Latitude": 21.17024,
      "Longitude": 72.831062,
      "State": "Gujarat"
  },
  {
      "id": "Suratgarh",
      "label": "Suratgarh",
      "Latitude": 29.320511,
      "Longitude": 73.899399,
      "State": "Rajasthan"
  },
  {
      "id": "Surendranagar",
      "label": "Surendranagar",
      "Latitude": 22.728392,
      "Longitude": 71.637077,
      "State": "Gujarat"
  },
  {
      "id": "Suri",
      "label": "Suri",
      "Latitude": 23.905445,
      "Longitude": 87.52462,
      "State": "West Bengal"
  },
  {
      "id": "Suryapet",
      "label": "Suryapet",
      "Latitude": 17.143908,
      "Longitude": 79.623924,
      "State": "Telangana"
  },
  {
      "id": "Suti",
      "label": "Suti",
      "Latitude": 24.618393,
      "Longitude": 88.024338,
      "State": "West Bengal"
  },
  {
      "id": "Tadepalligudem",
      "label": "Tadepalligudem",
      "Latitude": 16.814524,
      "Longitude": 81.526558,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Tambaram",
      "label": "Tambaram",
      "Latitude": 12.922915,
      "Longitude": 80.127457,
      "State": "Tamil Nadu"
  },
  {
      "id": "Tarabai Park",
      "label": "Tarabai Park",
      "Latitude": 16.713512,
      "Longitude": 74.248749,
      "State": "Maharashtra"
  },
  {
      "id": "Tenali",
      "label": "Tenali",
      "Latitude": 16.236719,
      "Longitude": 80.647476,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Tenkasi",
      "label": "Tenkasi",
      "Latitude": 8.959021,
      "Longitude": 77.312935,
      "State": "Tamil Nadu"
  },
  {
      "id": "Tezpur",
      "label": "Tezpur",
      "Latitude": 26.651218,
      "Longitude": 92.783813,
      "State": "Assam"
  },
  {
      "id": "Thalassery",
      "label": "Thalassery",
      "Latitude": 11.74805,
      "Longitude": 75.48938,
      "State": "Kerala"
  },
  {
      "id": "Thandalam",
      "label": "Thandalam",
      "Latitude": 12.999464,
      "Longitude": 80.117729,
      "State": "Tamil Nadu"
  },
  {
      "id": "Thane West",
      "label": "Thane West",
      "Latitude": 19.226662,
      "Longitude": 72.983833,
      "State": "Maharashtra"
  },
  {
      "id": "Thane",
      "label": "Thane",
      "Latitude": 19.21833,
      "Longitude": 72.978088,
      "State": "Maharashtra"
  },
  {
      "id": "Thanesar",
      "label": "Thanesar",
      "Latitude": 29.962072,
      "Longitude": 76.817825,
      "State": "Haryana"
  },
  {
      "id": "Thanjavur",
      "label": "Thanjavur",
      "Latitude": 10.786999,
      "Longitude": 79.137825,
      "State": "Tamil Nadu"
  },
  {
      "id": "Theni",
      "label": "Theni",
      "Latitude": 10.010366,
      "Longitude": 77.476814,
      "State": "Tamil Nadu"
  },
  {
      "id": "Thirunallar city",
      "label": "Thirunallar city",
      "Latitude": 10.930677,
      "Longitude": 79.787643,
      "State": "Puducherry"
  },
  {
      "id": "Thiruvalla",
      "label": "Thiruvalla",
      "Latitude": 9.383452,
      "Longitude": 76.574059,
      "State": "Kerala"
  },
  {
      "id": "Thiruvananthapuram",
      "label": "Thiruvananthapuram",
      "Latitude": 8.524139,
      "Longitude": 76.936638,
      "State": "Kerala"
  },
  {
      "id": "Thodupuzha",
      "label": "Thodupuzha",
      "Latitude": 9.897157,
      "Longitude": 76.713409,
      "State": "Kerala"
  },
  {
      "id": "Thrissur",
      "label": "Thrissur",
      "Latitude": 10.530345,
      "Longitude": 76.214729,
      "State": "Kerala"
  },
  {
      "id": "Tikamgarh",
      "label": "Tikamgarh",
      "Latitude": 24.756807,
      "Longitude": 78.839264,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Tiruchengode",
      "label": "Tiruchengode",
      "Latitude": 11.378476,
      "Longitude": 77.894493,
      "State": "Tamil Nadu"
  },
  {
      "id": "Tirumangalam",
      "label": "Tirumangalam",
      "Latitude": 9.823619,
      "Longitude": 77.986565,
      "State": "Tamil Nadu"
  },
  {
      "id": "Tirunelveli",
      "label": "Tirunelveli",
      "Latitude": 8.741222,
      "Longitude": 77.694626,
      "State": "Tamil Nadu"
  },
  {
      "id": "Tirupati",
      "label": "Tirupati",
      "Latitude": 13.629065,
      "Longitude": 79.424446,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Tirupattur",
      "label": "Tirupattur",
      "Latitude": 12.498351,
      "Longitude": 78.560196,
      "State": "Tamil Nadu"
  },
  {
      "id": "Tiruppur",
      "label": "Tiruppur",
      "Latitude": 11.110695,
      "Longitude": 77.348045,
      "State": "Tamil Nadu"
  },
  {
      "id": "Tirur",
      "label": "Tirur",
      "Latitude": 10.914627,
      "Longitude": 75.922096,
      "State": "Kerala"
  },
  {
      "id": "Tiruvannamalai",
      "label": "Tiruvannamalai",
      "Latitude": 12.228628,
      "Longitude": 79.066544,
      "State": "Tamil Nadu"
  },
  {
      "id": "Tumakuru",
      "label": "Tumakuru",
      "Latitude": 13.338263,
      "Longitude": 77.10141,
      "State": "Karnataka"
  },
  {
      "id": "Tuticorin",
      "label": "Tuticorin",
      "Latitude": 8.764166,
      "Longitude": 78.134834,
      "State": "Tamil Nadu"
  },
  {
      "id": "Udaipur",
      "label": "Udaipur",
      "Latitude": 24.57127,
      "Longitude": 73.691544,
      "State": "Rajasthan"
  },
  {
      "id": "Udamanda",
      "label": "Udamanda",
      "Latitude": 30.321989,
      "Longitude": 79.195412,
      "State": "Uttarakhand"
  },
  {
      "id": "Udgir",
      "label": "Udgir",
      "Latitude": 18.3934,
      "Longitude": 77.113144,
      "State": "Maharashtra"
  },
  {
      "id": "Udumalaipettai",
      "label": "Udumalaipettai",
      "Latitude": 10.5833,
      "Longitude": 77.25,
      "State": "Tamil Nadu"
  },
  {
      "id": "Udupi",
      "label": "Udupi",
      "Latitude": 13.340881,
      "Longitude": 74.742142,
      "State": "Karnataka"
  },
  {
      "id": "Ujjain",
      "label": "Ujjain",
      "Latitude": 23.1793,
      "Longitude": 75.784912,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Umred",
      "label": "Umred",
      "Latitude": 20.861378,
      "Longitude": 79.317856,
      "State": "Maharashtra"
  },
  {
      "id": "Unchahar",
      "label": "Unchahar",
      "Latitude": 25.9,
      "Longitude": 81.300003,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Unjha label",
      "label": "Unjha label",
      "Latitude": 23.804337,
      "Longitude": 72.393677,
      "State": "Gujarat"
  },
  {
      "id": "Unnao",
      "label": "Unnao",
      "Latitude": 26.536938,
      "Longitude": 80.48996,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Upleta",
      "label": "Upleta",
      "Latitude": 21.741323,
      "Longitude": 70.28112,
      "State": "Gujarat"
  },
  {
      "id": "Vadakara",
      "label": "Vadakara",
      "Latitude": 11.608495,
      "Longitude": 75.591705,
      "State": "Kerala"
  },
  {
      "id": "Vadapalani",
      "label": "Vadapalani",
      "Latitude": 13.052192,
      "Longitude": 80.212051,
      "State": "Tamil Nadu"
  },
  {
      "id": "Vadodara",
      "label": "Vadodara",
      "Latitude": 22.310696,
      "Longitude": 73.192635,
      "State": "Gujarat"
  },
  {
      "id": "Vaijapur",
      "label": "Vaijapur",
      "Latitude": 19.925682,
      "Longitude": 74.728477,
      "State": "Maharashtra"
  },
  {
      "id": "Vaniyambadi",
      "label": "Vaniyambadi",
      "Latitude": 12.695032,
      "Longitude": 78.621887,
      "State": "Tamil Nadu"
  },
  {
      "id": "Vapi",
      "label": "Vapi",
      "Latitude": 20.385181,
      "Longitude": 72.911453,
      "State": "Gujarat"
  },
  {
      "id": "Varanasi",
      "label": "Varanasi",
      "Latitude": 25.321684,
      "Longitude": 82.987289,
      "State": "Uttar Pradesh"
  },
  {
      "id": "Varthur",
      "label": "Varthur",
      "Latitude": 12.938482,
      "Longitude": 77.747711,
      "State": "Karnataka"
  },
  {
      "id": "Vasco da Gama",
      "label": "Vasco da Gama",
      "Latitude": 15.386033,
      "Longitude": 73.84404,
      "State": "Goa"
  },
  {
      "id": "Vashi",
      "label": "Vashi",
      "Latitude": 19.077065,
      "Longitude": 72.998993,
      "State": "Maharashtra"
  },
  {
      "id": "Vastral",
      "label": "Vastral",
      "Latitude": 22.99988,
      "Longitude": 72.660614,
      "State": "Gujarat"
  },
  {
      "id": "Vellore",
      "label": "Vellore",
      "Latitude": 12.934968,
      "Longitude": 79.146881,
      "State": "Tamil Nadu"
  },
  {
      "id": "Vidisha",
      "label": "Vidisha",
      "Latitude": 23.530001,
      "Longitude": 77.82,
      "State": "Madhya Pradesh"
  },
  {
      "id": "Vijayawada",
      "label": "Vijayawada",
      "Latitude": 16.515099,
      "Longitude": 80.632095,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Vijaypur",
      "label": "Vijaypur",
      "Latitude": 32.564522,
      "Longitude": 75.023148,
      "State": "Jammu and Kashmir"
  },
  {
      "id": "Vikramasingapuram",
      "label": "Vikramasingapuram",
      "Latitude": 8.699142,
      "Longitude": 77.411041,
      "State": "Tamil Nadu"
  },
  {
      "id": "Villupuram",
      "label": "Villupuram",
      "Latitude": 11.94596,
      "Longitude": 79.497414,
      "State": "Tamil Nadu"
  },
  {
      "id": "Viramgam",
      "label": "Viramgam",
      "Latitude": 23.125837,
      "Longitude": 72.057442,
      "State": "Gujarat"
  },
  {
      "id": "Virar",
      "label": "Virar",
      "Latitude": 19.465622,
      "Longitude": 72.806099,
      "State": "Maharashtra"
  },
  {
      "id": "Virudhachalam",
      "label": "Virudhachalam",
      "Latitude": 11.519588,
      "Longitude": 79.325157,
      "State": "Tamil Nadu"
  },
  {
      "id": "Virudhunagar",
      "label": "Virudhunagar",
      "Latitude": 9.587209,
      "Longitude": 77.951431,
      "State": "Tamil Nadu"
  },
  {
      "id": "Visakhapatnam",
      "label": "Visakhapatnam",
      "Latitude": 17.686815,
      "Longitude": 83.218483,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Visakhapatnam",
      "label": "Visakhapatnam",
      "Latitude": 17.690474,
      "Longitude": 83.231049,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Vizianagaram",
      "label": "Vizianagaram",
      "Latitude": 18.106659,
      "Longitude": 83.395554,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Wani",
      "label": "Wani",
      "Latitude": 20.067541,
      "Longitude": 78.958054,
      "State": "Maharashtra"
  },
  {
      "id": "Warangal",
      "label": "Warangal",
      "Latitude": 18.000055,
      "Longitude": 79.588165,
      "State": "Andhra Pradesh"
  },
  {
      "id": "Warora",
      "label": "Warora",
      "Latitude": 20.23,
      "Longitude": 79,
      "State": "Maharashtra"
  },
  {
      "id": "Washim",
      "label": "Washim",
      "Latitude": 20.1,
      "Longitude": 77.150002,
      "State": "Maharashtra"
  },
  {
      "id": "Yavatmal",
      "label": "Yavatmal",
      "Latitude": 20.388794,
      "Longitude": 78.120407,
      "State": "Maharashtra"
  },
  {
      "id": "Yelahanka",
      "label": "Yelahanka",
      "Latitude": 13.094454,
      "Longitude": 77.586014,
      "State": "Karnataka"
  },
  {
      "id": "Zirakpur",
      "label": "Zirakpur",
      "Latitude": 30.642803,
      "Longitude": 76.816902,
      "State": "Haryana"
  }
];
